/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface TeamUpdateResponse {
  /** 团队id */
  teamId?: string;
  /** 团队名称 */
  teamName?: string;
  /** 团队类型 */
  teamType?: string;
  /** 队长用户id */
  captainUserId?: string;
  /** 团队描述 */
  description?: string;
  /** 团队头像 */
  avatarUrl?: string;
  /** 团队背景图 */
  backgroundImage?: string;
  /**
   * 成员数量
   * @format int32
   */
  memberCount?: number;
  /**
   * 荣誉积分
   * @format int32
   */
  honorScore?: number;
  /**
   * 总荣誉积分
   * @format int32
   */
  totalHonorScore?: number;
  /** 团队状态 */
  status?: string;
  /**
   * 创建时间
   * @format int64
   */
  createdAt?: number;
  /**
   * 更新时间
   * @format int64
   */
  updatedAt?: number;
}

export interface WebResultUpdateTeamResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: TeamUpdateResponse;
}

export interface UpdateTeamRequest {
  /**
   * 战队头像URL
   * @example "https://example.com/avatar.png"
   */
  avatarUrl?: string;
  /**
   * 战队背景图片URL
   * @example "https://example.com/background.png"
   */
  backgroundImage?: string;
  /** 战队名称 */
  teamName?: string;
  /** 战队描述 */
  description?: string;
  /**
   * 战队类型：public(公开)/private(私有)
   * @example "private"
   */
  teamType?: string;
  /** 是否开启入队审核（仅 private 类型战队可开启） */
  joinAudit?: boolean;
}

export interface UpdateSocialPrivacyResponse {
  /**
   * 操作是否成功
   * @example true
   */
  success?: boolean;
  /**
   * 用户ID
   * @example "user_001"
   */
  userId?: string;
  /**
   * 社媒隐私状态：public(公开)/teamOnly(仅队友可见)/private(私密)
   * @example "teamOnly"
   */
  socialPrivacy?: "public" | "teamOnly" | "private";
}

export interface WebResultUpdateSocialPrivacyResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: UpdateSocialPrivacyResponse;
}

export interface VideoSessionInit {
  /** 视频观看会话ID */
  sessionId: string;
  /** 报告key */
  reportKey?: string;
  /** 该视频是否有奖励 */
  hasReward: boolean;
  /** 观看进度阶段区间定义 */
  stageRanges?: VideoSessionInitStageRangesInner[];
}

export interface VideoSessionInitResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: VideoSessionInit;
}

/** 观看进度阶段区间定义 */
export interface VideoSessionInitStageRangesInner {
  /**
   * 阶段级别，例如：1, 2, 3
   * @format int32
   */
  level?: number;
  /** 阶段名称，例如：第一阶段 */
  name?: string;
  /**
   * 最小比例值
   * @format double
   */
  minRatio?: number;
  /**
   * 最大比例值
   * @format double
   */
  maxRatio?: number;
  /** 奖励值 */
  rewardAmount?: string;
}

export interface VideoSessionInitRequest {
  /** 视频标识符 */
  videoId: string;
  /** 平台，例如YouTube */
  platform: string;
}

/** 事件列表 */
export interface EventData {
  /** 事件类型 */
  eventType?: string;
  /**
   * 事件时间戳
   * @format int64
   */
  timestamp?: number;
  /**
   * 事件序号
   * @format int32
   */
  sequence?: number;
  details?: EventDataDetails;
}

export type EventDataDetails = object;

export interface VideoEventsReportRequest {
  /** 会话ID */
  sessionId: string;
  /** 用户ID */
  customerId: string;
  /** 数据签名 */
  signature: string;
  /**
   * 客户端时间戳
   * @format int64
   */
  clientTimestamp: number;
  /** 社交平台 */
  socialPlatform?: "X" | "YouTube";
  /** 社交事件 */
  socialEvent?: "replay" | "watch";
  /** 事件列表 */
  events: EventData[];
  /** 设备指纹 */
  deviceFinger?: string;
  /** 客户端IP */
  clientIp?: string;
}

export interface TeamCreateResponse {
  /** 团队id */
  teamId?: string;
  /** 团队名称 */
  teamName?: string;
  /** 团队描述 */
  description?: string;
  /** 团队头像 */
  avatarUrl?: string;
  /** 背景图片 */
  backgroundImage?: string;
  /** 团队类型 */
  teamType?: string;
  /** 队长id */
  captainUserId?: string;
  /**
   * 成员数量
   * @format int32
   */
  memberCount?: number;
  /**
   * 成员最大数量
   * @format int32
   */
  maxMemberCount?: number;
  /**
   * 总荣誉分
   * @format int32
   */
  totalHonorScore?: number;
  /** 团队状态 */
  status?: string;
  /**
   * 创建时间
   * @format int64
   */
  createdAt?: number;
}

export interface WebResultCreateTeamResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: TeamCreateResponse;
}

export interface CreateTeamRequest {
  /** 团队名称 */
  name?: string;
  /** 团队描述 */
  description?: string;
  /** 团队头像 */
  avatarUrl?: string;
  /** 团队背景图 */
  backgroundImage?: string;
  /** 团队类型 */
  type?: string;
  /** 是否开启入队审核 */
  joinAudit?: boolean;
}

export interface TeamJoinResponse {
  /** 团队id */
  teamId?: string;
  /** 团队名称 */
  teamName?: string;
  /** 团队类型 */
  teamType?: string;
  /** 队长用户id */
  captainUserId?: string;
  /** 团队描述 */
  description?: string;
  /** 团队头像 */
  avatarUrl?: string;
  /** 团队背景图 */
  backgroundImage?: string;
  /**
   * 成员数量
   * @format int32
   */
  memberCount?: number;
  /**
   * 荣誉积分
   * @format int32
   */
  honorScore?: number;
  /**
   * 总荣誉积分
   * @format int32
   */
  totalHonorScore?: number;
  /** 团队状态 */
  status?: string;
  /**
   * 创建时间
   * @format int64
   */
  createdAt?: number;
  /**
   * 更新时间
   * @format int64
   */
  updatedAt?: number;
}

export interface WebResultJoinTeamResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: TeamJoinResponse;
}

export interface JoinTeamRequest {
  /** 团队ID */
  teamId?: string;
  /** 个人邀请码 */
  personalInviteCode?: string;
}

export interface TaskSocialEventResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: TaskSocialEventVO;
}

export interface TaskSocialEventVO {
  /** 奖励的等级，普通金或者金蛋 */
  rexyRewardLevel?: string;
  /** 奖励ID，收集蛋的时候需要上送 */
  rexyRewardId?: string;
  /**
   * 奖励的积分
   * @format int64
   */
  rexyRewardPoint?: number;
}

export interface TaskSocialEventRequest {
  /** 平台，例如X */
  platform: "X";
  /** 行为，例如replay */
  type: "replay";
  /** 回复内容 */
  replyContent?: string;
  signature?: string;
  /** 社交内容ID */
  socialContentId?: string;
  /** @format int64 */
  time: number;
  /** 设备指纹 */
  deviceFinger?: string;
}

export interface PersonaQuestsStatusResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
}

export interface PersonaQuestsStatusRequest {
  /** The customer's unique identifier for the app. */
  appCustomerId?: string;
  /** The task's unique identifier. */
  taskId?: string;
  /** The task's status. */
  status?: string;
  /**
   * The time the task was completed.
   * @format int64
   */
  completeTime?: number;
}

export interface UnBindSocialInfoResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
}

export interface UnbindSocialInfoRequest {
  customerId: string;
  /** 平台 */
  platform: string;
}

export interface BindSocialInfoResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
}

export interface BindSocialInfoRequest {
  customerId: string;
  /** 平台 */
  platform: string;
  socialId: string;
  socialHandleName?: string;
  socialProfileImage?: string;
  socialEmail?: string;
  publicMetrics?: string;
  verify?: boolean;
}

export interface JoinCampaign200Response {
  /** @example true */
  success: boolean;
  /** @example "0000" */
  code: string;
  /** @example "success" */
  message: string;
}

export interface ExtraRewardInfo {
  rexyRewardId?: string;
  rexyRewardPoint?: string;
}

export interface RewardCollect {
  rexyRewardLevel?: string;
  rexyRewardId?: string;
  rexyRewardPoint?: string;
  extraRewards?: ExtraRewardInfo[];
}

export interface RewardCollectResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: RewardCollect;
}

export interface RexyRewardCollectRequest {
  /** 奖励ID */
  rewardId?: string;
}

export interface ClaimResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: ClaimResponseAllOfObj;
}

export interface ClaimResponseAllOfObj {
  /** 金额 */
  amount?: string;
}

export interface RexyClaimRequest {
  /** 交易哈希 */
  transactionHash?: string;
  /** 调用数据 */
  callData?: string;
}

export interface ClaimBuildResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: ClaimBuildResponseAllOfObj;
}

export interface ClaimBuildResponseAllOfObj {
  /** 目标地址 */
  targetAddress?: string;
  /** 调用数据 */
  callData?: string;
  /** 金额 */
  amount?: string;
}

export interface SetRewardWalletResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: boolean;
}

export interface SetRewardWalletRequest {
  /** 已绑定的 EVM 钱包地址 */
  walletAddress?: string;
}

export interface BindWalletResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
}

export interface BindWalletRequest {
  /** 用户钱包地址 */
  address?: string;
  /** 用户钱包签名 */
  signature?: string;
  walletType?: "EVM" | "SOLANA";
  walletProvider?: "THIRDWEB" | "REOWN";
  socialPlatform?:
    | "GOOGLE"
    | "APPLE"
    | "FACEBOOK"
    | "DISCORD"
    | "LINE"
    | "X"
    | "COINBASE"
    | "FARCASTER"
    | "TELEGRAM"
    | "GITHUB"
    | "TWITCH"
    | "STEAM"
    | "GUEST"
    | "BACKEND"
    | "EMAIL"
    | "PHONE"
    | "PASSKEY"
    | "WALLET";
  /** 社媒账号详情 */
  accountDetail?: string;
  /** 绑定钱包来源 */
  source?: string;
}

export interface SetHandleNameResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
}

export interface EligiblePostResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
}

export interface EligiblePostRequest {
  /** 钱包地址 */
  evmAddress: string;
}

export interface UpdateMbtiResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
}

export interface UpdateMbtiRequest {
  /** MBTI人格类型，必须是16种有效类型之一（INTJ, INTP, ENTJ, ENTP, INFJ, INFP, ENFJ, ENFP, ISTJ, ISFJ, ESTJ, ESFJ, ISTP, ISFP, ESTP, ESFP） */
  mbti: string;
}

export interface SubmitLandingContactResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
}

export interface SubmitLandingContactRequest {
  /**
   * 联系邮箱
   * @example "contact@example.com"
   */
  email: string;
  /**
   * 项目官网 URL
   * @example "https://example.com"
   */
  websiteUrl?: string;
  /**
   * 项目目标（多选）
   * @example "[User Growth, Liquidity]"
   */
  projectGoals?: string[];
}

export interface CampaignApplicationResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  /** 申请单视图（OTS Model 镜像，Dubbo DTO 转换后返回） */
  obj?: CampaignApplicationVO;
}

/** 申请单视图（OTS Model 镜像，Dubbo DTO 转换后返回） */
export interface CampaignApplicationVO {
  /** UUID，前端拿到的 applicationId */
  id?: string;
  /** 状态（单维度状态机） */
  status?: "DRAFT" | "PENDING_REVIEW" | "APPROVED" | "REJECTED";
  /** 登录后从 JWT 解析；DRAFT 阶段允许为空 */
  passportId?: string;
  advertiserUrl?: string;
  /** DEFI / PERP_DEX / RWA / AI_DATA / MEMECOIN / GAMEFI / L1_L2 */
  advertiserType?: string;
  /** 提交时从 advertiser_intelligence 快照 */
  advertiserName?: string;
  selectedAudienceCodes?: string[];
  planTier?: "TRIAL" | "POPULAR" | "ENTERPRISE";
  /**
   * 提交时按 tier 静态配置写入快照
   * @format int64
   */
  planBudget?: number;
  /**
   * 提交时快照（天数）
   * @format int32
   */
  planDuration?: number;
  /** 关联 campaign_payment.id（仅 SUBMIT_PAYMENT 时设置） */
  paymentId?: string;
  /** Campaign payment detail view */
  payment?: CampaignPaymentVO;
  salesContactEmail?: string;
  salesContactTelegram?: string;
  salesContactMessage?: string;
  /** 审核通过后回填 */
  advertiserId?: string;
  /** 审核通过后回填 */
  campaignAdvertiseId?: string;
  /** 提交时记录的 IP（反作弊审计） */
  ipAddress?: string;
  /** @format int64 */
  created?: number;
  /** @format int64 */
  modified?: number;
}

/** Campaign payment detail view */
export interface CampaignPaymentVO {
  /** Local business order ID */
  id?: string;
  /** Associated application ID */
  applicationId?: string;
  /** Anchor-pay order ID */
  providerOrderId?: string;
  /** Amount in smallest unit (decimal string; may exceed int64 when decimals=18) */
  amount?: string;
  /** Token contract address */
  currency?: string;
  /** Token symbol */
  symbol?: string;
  /** Chain ID */
  chainId?: string;
  /** Recipient address */
  toAddress?: string;
  /** Payer wallet address */
  fromAddress?: string;
  /** On-chain transaction hash */
  txHash?: string;
  /** Payment status */
  status?: string;
  /** @format int64 */
  created?: number;
  /** @format int64 */
  modified?: number;
}

/** 创建/更新 application 共享 body schema */
export interface CreateOrUpdateApplicationRequest {
  /** 提交意图(PENDING, DRAFT, SUBMIT_PAYMENT, SUBMIT_SALES) */
  intent: string;
  /** 项目 URL（含协议） */
  advertiserUrl?: string;
  /** 用户选择的 audience codes（含 Customize 后） */
  selectedAudienceCodes?: string[];
  /** 套餐档位。intent=DRAFT 可空；SUBMIT_PAYMENT ∈ {TRIAL, POPULAR}；SUBMIT_SALES = ENTERPRISE */
  planTier?: "TRIAL" | "POPULAR" | "ENTERPRISE";
  /** 提交付款时由前端携带的支付信息（intent=SUBMIT_PAYMENT 必填） */
  payment?: PaymentInfoVO;
  /** Enterprise 套餐"联系销售"提交时的联系方式（intent=SUBMIT_SALES 必填，email/telegram 至少 1 个） */
  salesContact?: SalesContactInfoVO;
}

/** 提交付款时由前端携带的支付信息（intent=SUBMIT_PAYMENT 必填） */
export interface PaymentInfoVO {
  /** USDC / USDT */
  currency?: string;
  /** 1=ETH / 8453=Base / 42161=Arb / 56=BSC */
  chainId?: string;
  /** 用户付款钱包（0x + 40 hex） */
  walletAddress?: string;
}

/** Enterprise 套餐"联系销售"提交时的联系方式（intent=SUBMIT_SALES 必填，email/telegram 至少 1 个） */
export interface SalesContactInfoVO {
  /** 项目方邮箱 */
  email?: string;
  /** Telegram handle，例如 "@founder" */
  telegram?: string;
  /** 项目方备注 */
  message?: string;
}

export interface EventReportResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
}

/** 完成的事件列表 */
export interface EventItem {
  /** 事件的名称 */
  eventName?: string;
  /** event的唯一标识，用于防重 */
  eventId?: string;
  /** passport id 列表 */
  passports?: string[];
  /** 事件体，包含自定义的键值对 */
  eventBody?: Record<string, string>;
  /**
   * 事件时间戳
   * @format int64
   */
  eventTime?: number;
}

export interface EventReportRequest {
  /** 完成的事件列表 */
  events: EventItem[];
}

export interface SocialUploadResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
}

export interface SocialUploadRequest {
  /** 拦截的url */
  url: string;
  /** url body */
  body: string;
}

export interface ReservePrivacyAuthResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  /** 执行结果 */
  obj?: boolean;
}

export interface ReversePrivacyAuth {
  /** 授权平台 X or YouTube */
  platform?: string;
  /** reject 代表拒绝授权 */
  action?: string;
}

export interface UpdateNotifySwitchResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
}

export interface UpdateNotifySwitchRequest {
  /** switch name */
  name?: string;
  /** device type */
  deviceType?: string;
  /** switch status */
  status?: boolean;
}

export interface InviteBindResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
}

export interface InviteBindRequest {
  /** 邀请码 */
  inviteCode?: string;
  /** 邀请注册来源 */
  source?: string;
}

export interface FcmBindResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
}

export interface FcmBindRequest {
  /** fcm token */
  fcmToken?: string;
}

export interface AddWaitListResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
}

export interface AddWaitListRequest {
  /** 用户名 */
  name: string;
  /** 项目名 */
  project?: string;
  /** 邮箱 */
  email: string;
  /** 钱包地址 */
  evmAddress?: string;
}

export interface AddWaitDeveloperListResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
}

export interface AddWaitDeveloperListRequest {
  /** 项目名称 */
  projectName: string;
  /** 项目类别，可多选 */
  projectCategory: string[];
  /** 若项目类别选择 'Others'，请填写具体内容 */
  projectCategoryOther?: string;
  /** 简要描述您的项目、使命及其解决的问题 */
  projectDescription: string;
  /** 解释您的项目如何利用 T-Rex 并为生态系统带来什么价值 */
  ecosystemAlignment: string;
  /** 项目所处阶段 */
  projectStage: string;
  /** 项目网站 URL */
  projectWebsite: string;
  /** 项目 Twitter URL */
  projectTwitter?: string;
  /** 项目社区（Telegram 群组、Discord 等）URL */
  projectCommunity?: string;
  /** 主要联系人姓名 */
  primaryContactName: string;
  /** 联系人邮箱 */
  contactEmail: string;
  /** 联系人 Telegram 用户名（可选） */
  contactTelegram?: string;
  /** 寻求的支持类型，可多选 */
  supportType: string[];
  /** 若支持类型选择 'Other'，请填写具体内容 */
  supportTypeOther?: string;
  /** 简要概述计划如何使用申请的资金 */
  useOfFunds: string;
  /** 介绍您的核心团队及相关经验 */
  teamBackground: string;
  /** 上传项目推介材料或支持文档（文件上传或 URL） */
  supportingDocuments?: string;
  /** 其他需要我们了解的信息（可选） */
  additionalComments?: string;
}

export interface AddDeveloperWaitListUploadResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: AddDeveloperWaitListUploadResponseAllOfObj;
}

export interface AddDeveloperWaitListUploadResponseAllOfObj {
  /** 上传文件的名称 */
  fileName?: string;
  /** 上传文件的路径 */
  filePath?: string;
}

export interface AddWaitCreatorListResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
}

export interface AddWaitCreatorListRequest {
  /** 你的姓名 */
  name: string;
  /** 联系邮箱 */
  contactEmail?: string;
  /** 联系 Telegram 用户名 */
  contactTelegram?: string;
  /** 联系 Discord 用户名 */
  contactDiscord?: string;
  /** 其他联系方式 */
  contactOther?: string;
  /** Instagram 账号 */
  socialsInstagram?: string;
  /** twitter 账号 */
  socialsTwitter?: string;
  /** youtube 账号 */
  socialsYoutube?: string;
  /** Tiktok 账号 */
  socialsTiktok?: string;
  /** Telegram 账号 */
  socialsTelegram?: string;
  /** 其他账号 */
  socialsOther?: string;
  /** 你创作的内容类型，可多选 */
  contentTypes?: string[];
  /** 若内容类型选择 'Others'，请填写具体内容 */
  contentTypesOther?: string;
  /** 你有兴趣加入 Trex 创作者计划的原因，可多选 */
  interestReasons?: string[];
  /** 若原因选择 'Others'，请填写具体内容 */
  interestReasonsOther?: string;
}

export interface CampaignAirdropProof {
  /** 空投合约地址 */
  contractAddress?: string;
  /**
   * Factory 分配链上 airdropId
   * @format int64
   */
  airdropId?: number;
  /**
   * 叶子序号
   * @format int64
   */
  merkleIndex?: number;
  /** 展示用奖励金额 */
  amount?: string;
  /** 合约调用金额 */
  amountInWei?: string;
  /** 奖励钱包地址 */
  rewardWalletAddress?: string;
  /** bytes32[] merkle proof */
  merkleProof?: string[];
  /** 链 ID */
  chainId?: string;
  /** ERC20 代币地址 */
  tokenAddress?: string;
  /** 领取状态 */
  status?: string;
  /** claim 交易哈希 */
  txHash?: string;
}

export interface CampaignClaimRewardResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: CampaignAirdropProof;
}

export interface CampaignSquadRewardResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
}

export interface CampaignSquadContributeResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: CampaignSquadContributeResponseAllOfObj;
}

export interface CampaignSquadContributeResponseAllOfObj {
  /** 用户当前的贡献值 */
  contribute?: string;
}

export interface CampaignHatchResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: CampaignHatchResponseAllOfObj;
}

export interface CampaignHatchResponseAllOfObj {
  /**
   * 当前锁定档位
   * @format int32
   */
  dinosaurLevel?: number;
  /** 是否锁定成功 */
  dinosaurLevelLocked?: boolean;
}

export interface HatchCampaignLevelRequest {
  /**
   * 上次返回给前端的用户将要锁定的等级（与 participation.yield / 档位数字一致），用于与当前服务端定级结果比对
   * @format int32
   */
  yield: number;
}

export interface ThirdAuthorizeInfo {
  /** 用户id */
  customerId?: string;
  /** 三方用户id */
  socialUserId?: string;
  /** 三方用户名 */
  socialHandleName?: string;
  /** 三方头像 */
  socialProfileImage?: string;
}

export interface ThirdAuthorizeResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: ThirdAuthorizeInfo;
}

export interface ThirdAuthorizeRequest {
  /** 授权平台 */
  platform: string;
  /** 授权code */
  code: string;
}

export interface AccessToken {
  /** 访问token */
  accessToken?: string;
  /** 刷新token */
  refreshToken?: string;
  /** 是否新用户 */
  isNewUser?: boolean;
  /** 是否新通行证 */
  isNewPassport?: boolean;
  /** 是否兑换成功 */
  isRedeemedSuccessfully?: boolean;
}

export interface AccessTokenResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: AccessToken;
}

export interface LoginRequest {
  /** 钱包地址 */
  walletAddress: string;
  /** thirdWeb签名 */
  signature: string;
  /** 验证码 */
  code?: string;
  /** 社媒类型 */
  socialPlatform?: string;
  /** 登录来源；C 端默认 portal，Growth Portal 必传 growth；用于在 JWT 中写入 audience claim */
  source?: "portal" | "growth";
}

export interface LogoutResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
}

export interface NftHold {
  /** @format int32 */
  limit?: number;
  /** @format int32 */
  quantity?: number;
}

export interface NftHoldResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: NftHold;
}

export interface FaucetDripResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: FaucetDripResponseAllOfObj;
}

export interface FaucetDripResponseAllOfObj {
  /** 目标地址 */
  targetAddress?: string;
  /** 调用数据 */
  callData?: string;
  /** 金额 */
  amount?: string;
  /** 交易哈希 */
  txHash?: string;
}

export interface TeamCode {
  /** 我在战队中的邀请码 */
  code?: string;
  /** 个人的邀请码 */
  referralCode?: string;
  /** 战队的唯一标识 */
  teamId?: string;
  /** 用户的唯一标识 */
  passportId?: string;
  /** 邀请场景 */
  scene?: string;
}

export interface TeamCodeResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: TeamCode;
}

export interface WebResultTeamDetailResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: WebResultTeamDetailResponseAllOfObj;
}

export interface WebResultTeamDetailResponseAllOfObj {
  /**
   * 团队唯一ID
   * @example "team_1234567890"
   */
  teamId?: string;
  /**
   * 团队名称
   * @example "Elite Hunters"
   */
  name?: string;
  /**
   * 团队描述
   * @example "Top performers unite"
   */
  description?: string;
  /**
   * 团队头像URL
   * @example "https://example.com/team-avatar.jpg"
   */
  avatarUrl?: string;
  /**
   * 团队背景图片URL
   * @example "https://example.com/team-bg.jpg"
   */
  backgroundImage?: string;
  /**
   * 团队类型
   * @example "PRIVATE"
   */
  teamType?: string;
  /** 队长用户ID */
  captainUserId?: string;
  /** 队长用户名 */
  captainUserName?: string;
  /**
   * 当前成员数量
   * @format int32
   * @example 45
   */
  memberCount?: number;
  /**
   * 最大成员数量
   * @format int32
   * @example 50
   */
  maxMembers?: number;
  /**
   * 团队总荣誉积分
   * @format int32
   * @example 98750
   */
  totalHonorScore?: number;
  /**
   * 团队状态
   * @example "ACTIVE"
   */
  status?: string;
  /**
   * 创建时间的时间戳（毫秒）
   * @format int64
   * @example 1672531200000
   */
  createdAt?: number;
  /**
   * 最后更新时间的时间戳（毫秒）
   * @format int64
   * @example 1672617600000
   */
  updatedAt?: number;
  /**
   * 当前用户在团队中的角色
   * @example "MEMBER"
   */
  myRole?: string;
  /**
   * 当前用户加入团队的时间戳（毫秒）
   * @format int64
   * @example 1672531200000
   */
  myJoinedAt?: number;
  /** 团队徽章分类列表 */
  badgeCategories?: string[];
  /**
   * 团队排名
   * @format int32
   * @example 150
   */
  globalRank?: number;
  /** 徽章总结信息 */
  badgeSummary?: WebResultTeamDetailResponseAllOfObjBadgeSummary;
}

/** 徽章总结信息 */
export interface WebResultTeamDetailResponseAllOfObjBadgeSummary {
  /**
   * 已解锁的徽章总数
   * @format int32
   * @example 12
   */
  totalUnlocked?: number;
  /**
   * 徽章总荣誉积分
   * @format int32
   * @example 6200
   */
  totalHonorScore?: number;
}

export interface QueryBySocialInfo {
  /** 授权平台 */
  platform?: string;
  /** passportId */
  passportId?: string;
  /** 社媒userId */
  socialUserId?: string;
  /** 社媒用户名 */
  socialHandleName?: string;
  /** 社媒邮箱 */
  socialEmail?: string;
}

export interface QueryBySocialInfoResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: QueryBySocialInfo;
}

export interface InviteInfo {
  /** 用户id */
  customerId?: string;
  /** 用户注册时的钱包地址 */
  address?: string;
  /** 邀请码 */
  inviteCode?: string;
  /**
   * 邀请人数
   * @format int32
   */
  inviteCount?: number;
  /**
   * 邀请奖励
   * @format int32
   */
  inviteClaimedReward?: number;
  /**
   * 邀请未领取的奖励
   * @format int32
   */
  inviteUnClaimedReward?: number;
  /** 邀请规则 */
  inviteRule?: string;
  /** 邀请人 */
  inviter?: string;
  /**
   * 邀请返佣比例
   * @format int32
   */
  commission?: number;
  /** 邀请返佣发放的资产类型 */
  commissionAssetType?: string;
}

export interface InviteInfoResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: InviteInfo;
}

export interface AssetTokenResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: string;
}

export interface AssetNFTResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: string;
}

export interface AssetBadgeResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: object;
}

export interface RexyReward {
  /**
   * 奖励所属阶段
   * @format int32
   */
  stage?: number;
  /** 恐龙蛋编号，产生奖励后存在 */
  code?: string;
  point?: string;
  rewards?: RexyRewardItem[];
}

export interface RexyRewardItem {
  /**
   * 奖励所属阶段
   * @format int32
   */
  stage?: number;
  /** 恐龙蛋编号，产生奖励后存在 */
  code?: string;
  point?: string;
  /** 是否隐藏 */
  hidden?: boolean;
  status?: "EXPIRED" | "CLAIMED" | "UNCLAIMED";
}

export interface RexyRewardLastResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: RexyReward;
}

export interface RexyInfo {
  /** 用户id */
  customerId?: string;
  /** 头像 */
  avatar?: string;
  /**
   * 积分
   * @format int64
   */
  point?: number;
  rexy?: RexyInfoRexy;
}

export interface RexyInfoResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: RexyInfo;
}

export interface RexyInfoRexy {
  /** 恐龙id */
  id?: string;
  /** 恐龙名称 */
  name?: string;
  /**
   * 购物车积分
   * @format int32
   */
  basketPoint?: number;
  /**
   * 篮子积分上限
   * @format int32
   */
  limitPoint?: number;
  /**
   * 当前产生速率
   * @format int32
   */
  rate?: number;
  /** 头像 */
  avatar?: string;
}

export interface Rexys {
  /** 恐龙id */
  id?: string;
  /** 恐龙编号 */
  code?: string;
  /** 图片 */
  image?: string;
  /** 小图 */
  miniImage?: string;
  /** level */
  level?: string;
  /**
   * 生产速率
   * @format int32
   */
  rate?: number;
  /**
   * 篮子上限
   * @format int32
   */
  limit?: number;
  /**
   * 状态, 0:coming soon 1:lock 2:open
   * @format int32
   */
  status?: number;
  /** 是否拥有 */
  has?: boolean;
  /** 是否选中 */
  selected?: boolean;
}

export interface RexysResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: Rexys[];
}

export interface PersonaVO {
  /** code */
  code?: string;
  /** parent code */
  parentCode?: string;
  /** type */
  type?: string;
  /** name */
  name?: string;
  /** title */
  title?: string;
  /** desc */
  desc?: string;
  /** remark */
  remark?: string;
  /** icon */
  icon?: string;
  /**
   * sort
   * @format int32
   */
  sort?: number;
  /**
   * threshold value
   * @format int32
   */
  threshold?: number;
  /**
   * achieved value
   * @format int32
   */
  achieved?: number;
  /**
   * boost
   * @format int32
   */
  boost?: number;
  /**
   * reward point
   * @format int32
   */
  reward?: number;
  /** status */
  status?: string;
  /** status(DONE) */
  taskStatus?: string;
  /** channel */
  channel?: string;
  /** ref type */
  refType?: string;
  /** ref codes */
  refCodes?: string[];
  /** ref attributes */
  refAttrs?: string;
  /** anchor token ids */
  anchorTokenId?: string[];
  /** has next */
  hasNext?: boolean;
  /** next nodes */
  nextNodes?: PersonaVO[];
}

export interface PersonasResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: PersonasResponseAllOfObj;
}

export interface PersonasResponseAllOfObj {
  parent?: PersonaVO;
  nodes?: PersonaVO[];
}

export interface PersonaStatsResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: PersonaStatsVO;
}

export interface PersonaStatsVO {
  /**
   * total boost
   * @format int32
   */
  totalBoost?: number;
  nodes?: PersonaStatsVONodesInner[];
}

export interface PersonaStatsVONodesInner {
  /** code */
  code?: string;
  /** code */
  name?: string;
  /**
   * boost
   * @format int32
   */
  boost?: number;
  /**
   * total task size
   * @format int32
   */
  total?: number;
  /**
   * threshold value
   * @format int32
   */
  threshold?: number;
  /**
   * achieved value
   * @format int32
   */
  achieved?: number;
}

export interface PersonaFeatureResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: PersonaFeatureVO;
}

export interface PersonaFeatureVO {
  /** social connected platforms */
  socialConnectedPlatforms?: string;
  /**
   * total followers
   * @format int32
   */
  totalFollowers?: number;
  /** bluechips and stable holding value */
  bluechipsAndStableHoldingValue?: number;
  /**
   * bluechips nft holding number
   * @format int32
   */
  bluechipsNftHoldingNumber?: number;
  /**
   * rexy nft holding number
   * @format int32
   */
  rexyNftHoldingNumber?: number;
  /** total swapdex trading volume */
  totalSwapdexTradingVolume?: number;
  /** total perpdex trading volume */
  totalPerpdexTradingVolume?: number;
  /** first onchain interaction time (yyyy-MM-dd HH:mm:ss) */
  firstOnchainInteractionTime?: string;
}

export interface EligibleGetObj {
  /** evm 地址 */
  evmAddress?: string;
  /** 是否符合mint条件 */
  isEligible?: boolean;
  /** 是否结束标记 */
  isEnd?: boolean;
}

export interface EligibleGetResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: EligibleGetObj;
}

/** nft conditions and progress */
export interface NftProgressVO {
  /** condition number */
  condition?: string;
  /** condition name */
  name?: string;
  /** condition type */
  type?: string;
  /** progress value */
  value?: string;
}

/** all nfts in series */
export interface NftVO {
  /**
   * minted Count
   * @format int64
   */
  mintedCount?: number;
  /** nft series logo */
  seriesLogo?: string;
  /** claimable id */
  claimableId?: string;
  /** nft type */
  type?: string;
  /**
   * nft tier
   * @format int32
   */
  tier?: number;
  /** price */
  price?: string;
  /** nft gateway logo */
  logo?: string;
  /**
   * reward
   * @format int32
   */
  reward?: number;
  /** show new tag */
  newTag?: boolean;
  /** nft complete process */
  process?: number;
  /** nft contract address */
  address?: string;
  /** nft token id */
  tokenId?: string;
  /** level */
  level?: string;
  /** nft series name */
  seriesName?: string;
  /**
   * total supply
   * @format int64
   */
  totalSupply?: number;
  /** nft condition max */
  maxCond?: number;
  /**
   * nft claimed time
   * @format int64
   */
  claimTime?: number;
  /** currency */
  token?: string;
  /** nft series type */
  series?: string;
  /** nft condition min */
  minCond?: number;
  /** nft name */
  name?: string;
  /** nft conditions and progress */
  progress?: NftProgressVO[];
  /** category */
  category?: string;
  /** nft desc */
  desc?: string;
  /** nft status(pending、claimable、claimed) */
  status?: string;
}

export interface PassportInfo {
  /** 用户ID */
  passportId?: string;
  /**
   * 创建时间
   * @format int64
   */
  created?: number;
  /** 用户名称 */
  userName?: string;
  /** 用户昵称或标识 */
  handleName?: string;
  /** 用户地址 */
  addresses?: string;
  /** 邮箱地址 */
  email?: string;
  /** KYC等级 */
  kycLevel?: string;
  /** 链id */
  chainId?: string;
  /** 登录方式 */
  authProvider?: string;
  /** 邀请码 */
  inviteCode?: string;
  /** 头像 */
  avatar?: string;
  /** 持有的称号 */
  holdTitles?: string[];
  /**
   * passportChainId
   * @format int32
   */
  passportChainId?: number;
  /** contractAddress */
  contractAddress?: string;
  /**
   * point
   * @format int64
   */
  point?: number;
  badges?: NftVO[];
  /** MBTI人格类型 */
  mbti?: string;
  /** 登录社交账号 */
  loginSocialAccount?: string;
}

export interface PassportResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: PassportInfo;
}

export interface PassportConnectInfo {
  /** 钱包地址 */
  walletAddress?: string;
  /** 钱包类型 eg. EVM / Solana / Social */
  walletType?: string;
  /** 连接类型 eg. BIND / KEY */
  connectType?: string;
  /** 子连接提供商 eg. google / facebook / apple ... */
  subConnectProvider?: string;
  /** 是否为全局奖励钱包 */
  isRewardWallet?: boolean;
  /**
   * 设置为奖励钱包的时间戳（毫秒）
   * @format int64
   */
  rewardWalletSetAt?: number;
}

export interface PassportConnectResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: PassportConnectInfo[];
}

export interface Notice {
  /** 通知 id */
  id?: string;
  /** 标题 */
  title?: string;
  /** 副标题 */
  subTitle?: string;
  /** 内容 */
  content?: string;
  /** 链接 */
  link?: string;
}

export interface NoticeResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: Notice[];
}

export interface NewsInfo {
  /** id */
  id?: string;
  /** 类型 Article、News、YouTube、DApp、XPost */
  type?: string;
  /** 名称 */
  name?: string;
  /** logo链接 */
  logo?: string;
  /** 标题 */
  title?: string;
  /** 子标题 */
  subTitle?: string;
  /** 图片 */
  image?: string;
  /** 外部链接 */
  link?: string;
  /** 标签 */
  category?: string[];
  /** 来源icon图标 */
  tag?: string;
  /**
   * 发布时间
   * @format int64
   */
  date?: number;
  /** 是否推荐置顶 */
  isRecommend?: boolean;
  /** 是否有奖励 */
  isReward?: boolean;
}

export interface NewsInfoResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: NewsInfo[];
}

export interface DiscoveryEvents {
  /** id */
  id?: string;
  /** 标题 */
  title?: string;
  /** 摘要 */
  summary?: string;
  /** 图片 */
  image?: string;
  /** 外部链接 */
  link?: string;
  /** 组织者 */
  organizer?: string;
  /** 地点 */
  location?: string;
  /**
   * 开始时间
   * @format int64
   */
  activityStartTime?: number;
  /**
   * 结束时间
   * @format int64
   */
  activityEndTime?: number;
  /** 剩余时间 */
  remainingTime?: string;
}

export interface DiscoveryEventsResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: DiscoveryEvents[];
}

export interface DiscoveryBlog {
  /** id */
  id?: string;
  /** 标题 */
  title?: string;
  /** 子标题，灰色小字 */
  type?: string;
  /** 摘要 */
  summary?: string;
  /** 正文内容链接 */
  link?: string;
  /** 正文内容 */
  content?: string;
  /** 图片 */
  image?: string;
  /** 是否推荐置顶 */
  isRecommend?: boolean;
  /**
   * 创建时间
   * @format int64
   */
  created?: number;
}

export interface DiscoveryBlogResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: DiscoveryBlog[];
}

export interface OnboardingConfigResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  /** Onboarding payment config snapshot */
  obj?: OnboardingPaymentConfigVO;
}

/** Onboarding payment config snapshot */
export interface OnboardingPaymentConfigVO {
  enabled?: boolean;
  chains?: string[];
  currencies?: OnboardingPaymentConfigVOCurrenciesInner[];
  recipients?: OnboardingPaymentConfigVOCurrenciesInnerTokenAddressesInner[];
  anchorPay?: OnboardingPaymentConfigVOCurrenciesInnerTokenAddressesInner[];
  plans?: OnboardingPaymentConfigVOPlansInner[];
}

export interface OnboardingPaymentConfigVOCurrenciesInner {
  symbol?: string;
  tokenAddresses?: OnboardingPaymentConfigVOCurrenciesInnerTokenAddressesInner[];
}

export interface OnboardingPaymentConfigVOCurrenciesInnerTokenAddressesInner {
  chainId?: string;
  address?: string;
}

export interface OnboardingPaymentConfigVOPlansInner {
  tier?: string;
  enabled?: boolean;
  recommended?: boolean;
  action?: string;
  /** @format int64 */
  budget?: number;
  /** @format int32 */
  durationDays?: number;
  quests?: string;
  estActions?: string;
  description?: string;
  bullets?: string[];
}

/** Audience Segment 卡片（PRISM 推荐 / Customize 全集） */
export interface AudienceSegmentCardVO {
  /** 例如 DEFI_TRADER */
  code: string;
  /** 例如 "DeFi Trader" */
  displayName: string;
  icon?: string;
  description?: string;
  /** 例如 ["Uniswap V3 LP", ...] */
  featureTags?: string[];
  /**
   * 当前覆盖人数（大数据每日跑批写入）
   * @format int64
   */
  populationCount?: number;
  /**
   * 大数据写入时间戳
   * @format int64
   */
  populationUpdatedAt?: number;
  /** 是否为被推荐项 */
  recommended?: boolean;
}

export interface AudienceSegmentListResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: AudienceSegmentCardVO[];
}

/** 项目情报（OTS Model AdvertiserIntelligence 的视图） */
export interface AdvertiserIntelligenceVO {
  /** normalize(URL) 或 X handle */
  id?: string;
  advertiserName?: string;
  /** DEFI / PERP_DEX / RWA / AI_DATA / MEMECOIN / GAMEFI / L1_L2 */
  advertiserType?: string;
  rawTags?: string[];
  description?: string;
  logoUrl?: string;
  websiteUrl?: string;
  twitterHandle?: string;
  /** rootdata / manual / mixed */
  dataSource?: string;
  /** @format int64 */
  lastFetchedAt?: number;
  /** @format int64 */
  created?: number;
  /** @format int64 */
  modified?: number;
}

export interface AnalysisResultResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  /** advertiser-intelligence 接口聚合返回视图 */
  obj?: AnalysisResultVO;
}

/** advertiser-intelligence 接口聚合返回视图 */
export interface AnalysisResultVO {
  /** 项目情报（OTS Model AdvertiserIntelligence 的视图） */
  intelligence?: AdvertiserIntelligenceVO;
  /** intelligence != null && advertiserType != null */
  recognized: boolean;
  audiences?: AudienceSegmentCardVO[];
}

export interface PrivacyAuthResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: PrivacyAuthVO;
}

export interface PrivacyAuthVO {
  /** X平台隐私授权状态 */
  privacyAuthX?: boolean;
  /** youtube平台的隐私授权状态 */
  privacyAuthYoutube?: boolean;
  /** zktls技术的隐私授权状态 */
  privacyAuthZktls?: boolean;
  /** 是否弹出授权提示 */
  popAuthPrompt?: boolean;
}

export interface NotifySwitchResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  switchs?: NotifySwitchResponseAllOfSwitchs[];
}

export interface NotifySwitchResponseAllOfSwitchs {
  name?: string;
  device?: string;
  status?: boolean;
}

export interface NotificationHistory {
  /** 消息唯一标识符 */
  messageId?: string;
  data?: NotificationHistoryData;
}

export interface NotificationHistoryData {
  /**
   * 消息发送时间戳
   * @format int64
   * @example 1766046208276
   */
  sendTime?: number;
  /**
   * 消息标题
   * @example "1217test"
   */
  title?: string;
  /**
   * 消息内容
   * @example "1217test"
   */
  body?: string;
  /**
   * 消息过期时间戳
   * @format int64
   * @example 1766215840000
   */
  expiredTime?: number;
  /**
   * 消息标签
   * @example "cc"
   */
  tag?: string;
  /**
   * 消息数据ID
   * @example "d059291d4e30418a94575eb49d839a1a"
   */
  id?: string;
  /**
   * 消息图片URL
   * @example "https://quests-dev.oss-ap-southeast-1.aliyuncs.com/quests/trex/asset_check_chain_token.png"
   */
  image?: string;
  /** 跳转链接 */
  targetLink?: string;
}

export interface NotificationHistoryResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: NotificationHistory[];
}

export interface Advertiser {
  /** 活动标题 */
  title?: string;
  /** 活动描述 */
  description?: string;
  /** 项目方logo */
  logo?: string;
  /** 项目方 banner */
  banner?: string;
  /** 分享X用的图片 */
  shareXImage?: string;
  /** 积分图标 */
  pointsIcon?: string;
  /** 项目方展示的标签 */
  tags?: string[];
  /** 开始时间戳 */
  start?: string;
  /** 活动截止的时间戳 */
  end?: string;
  /** 活动下线的时间戳 */
  offlineTime?: string;
  /** 空投开始时间戳（airdrop_start），空投开始前不返回空投结果和badge信息 */
  airdrop?: string;
  /** 空投可以claim的截止时间，不设置则不返回 */
  airdropEnd?: string;
  /** 当前空投是否可以claim，只有当已经导入空投且允许领取时返回true，其余场景返回false */
  canClaim?: boolean;
  /**
   * 参与人数，status=outcoming时返回0
   * @format int64
   */
  participantCount?: number;
  /** 奖励池，status=outcoming时返回null */
  rewardPool?: RewardItem[];
  /** 状态，outcoming / run / settle / claim / end */
  status?: string;
  /** 社媒链接列表 */
  socialLinks?: SocialLinkItem[];
  /** 空投的规则描述 */
  airdropRules?: string;
  /** 空投后给用户发的badge的tokenId。未配置或当前时间未到airdrop_start时不返回 */
  badgeTokenId?: string;
  /** 当前项目方关联的 badge categories，用于页面关联展示 badge */
  badgeRefCategories?: string[];
  /**
   * 达成有效邀请积分的门槛
   * @format int32
   */
  inviteThreshold?: number;
  /**
   * 邀请返佣比例
   * @format int32
   */
  inviteCommission?: number;
  /**
   * 邀请返佣奖励的上限
   * @format int32
   */
  inviteRewardLimit?: number;
}

export interface Campaign {
  /** Campaign的ID标识 */
  campaignId?: string;
  /** 项目方的ID */
  advertiserId?: string;
  /** 是否为alpha测试活动 */
  alpha?: boolean;
  /** campaign_advertiser_id，项目方在campaign中的标识 */
  campaignAdvertiserId?: string;
  /** quest的积分类型 */
  assetType?: string;
  advertiser?: Advertiser;
  persona?: CampaignPersona;
}

export interface CampaignPersona {
  tle?: CampaignPersona;
  /** 是否已经加入 */
  joined?: boolean;
  /** 是否已解锁yield加成 */
  unlocked?: boolean;
  /** 是否已锁档（hatch 后置为 true） */
  tireLocked?: boolean;
  /** yield加成值，格式为小数（如0.34表示34%），unlocked=false时返回null */
  yield?: string;
  /** PMS算出来的加成，预留 */
  pmsYield?: string;
  /** RexyNFT的加成，预留 */
  nftYield?: string;
  /** 排名百分比，格式为小数（如0.01表示top 1%），unlocked=false时返回null */
  top?: string;
  /**
   * yield的最后更新时间戳
   * @format int64
   */
  lastUpdateTime?: number;
  /** 用户收到的空投汇总奖励，无结果时为null */
  airdrop?: CampaignPersonaAirdropInner[];
  /** 用户收到的空投明细，无结果时为null */
  airdropDetail?: CampaignPersonaAirdropDetailInner[];
  /** 用户是否已经领取了空投奖励，unclaim-未领取,claimed-已领取 */
  claimStatus?: string;
  /** 结算完成后的快照数据；仅当活动已结束且结算完成时返回，否则为null */
  settle?: CampaignPersonaSettle;
}

/** 用户收到的空投明细，无结果时为null */
export interface CampaignPersonaAirdropDetailInner {
  /** 明细类型（例如 lucky / reffer） */
  type?: string;
  /** 奖励数量（BigDecimal） */
  amount?: number;
  /** 奖励币种符号 */
  symbol?: string;
}

/** 用户收到的空投汇总奖励，无结果时为null */
export interface CampaignPersonaAirdropInner {
  /** 奖励数量（BigDecimal） */
  amount?: number;
  /** 奖励币种符号 */
  symbol?: string;
}

/** 结算完成后的快照数据；仅当活动已结束且结算完成时返回，否则为null */
export interface CampaignPersonaSettle {
  /** 结算后的yield加成 */
  yield?: string;
  /** yield的档位或排名百分比 */
  top?: string;
  /** 基础积分 */
  basePoint?: string;
  /** 加成后的积分 */
  yieldPoint?: string;
  /** 积分排名 */
  rank?: string;
  /** 已完成的任务数 */
  finishedQuests?: string;
}

export interface CampaignsResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: CampaignsResponseAllOfObj;
}

export interface CampaignsResponseAllOfObj {
  campaigns?: Campaign[];
  /** 服务器的当前时间 */
  ts?: string;
}

/** 奖励池，status=outcoming时返回null */
export interface RewardItem {
  /** 币种符号 */
  symbol?: string;
  /** 奖励金额 */
  amount?: string;
  /** 币种图标 */
  icon?: string;
}

/** 社媒链接列表 */
export interface SocialLinkItem {
  /** 社媒平台名称，如twitter、discord、telegram等 */
  name?: string;
  /** 社媒链接地址 */
  url?: string;
  /** 社媒平台图标链接 */
  icon?: string;
}

export interface AdvertiserDetail {
  /** Campaign的ID标识 */
  campaignId?: string;
  /** 项目方的ID */
  advertiserId?: string;
  /** campaign_advertiser_id，项目方在campaign中的标识 */
  campaignAdvertiserId?: string;
  /** quest的积分类型 */
  assetType?: string;
  /** 资产类型 */
  assetTypes?: Record<string, string>;
  advertiser?: Advertiser;
  persona?: CampaignPersona;
  /** 服务器的当前时间 */
  ts?: string;
}

export interface AdvertiserDetailResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: AdvertiserDetail;
}

export interface CampaignTasksResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: CampaignTasksResponseAllOfObj;
}

export interface CampaignTasksResponseAllOfObj {
  tasks?: Task[];
}

export interface Task {
  /** 任务code */
  code?: string;
  /** 父任务的code */
  parentCode?: string;
  /** quests的任务ID */
  taskId?: string;
}

export interface CampaignSquadTasksResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: CampaignSquadTasksResponseAllOfObj;
}

export interface CampaignSquadTasksResponseAllOfObj {
  /** 任务列表 */
  tasks?: SquadTask[];
  /** 所在战队的信息 */
  squad?: SquadInfo;
}

/** 所在战队的信息 */
export interface SquadInfo {
  /** 战队的id */
  code?: string;
  /** 战队名称 */
  name?: string;
  /** 战队描述 */
  description?: string;
  /** 头像的背景 */
  background?: string;
  /** 战队头像 */
  icon?: string;
  /**
   * 总人数
   * @format int32
   */
  total?: number;
  /**
   * 当前人数
   * @format int32
   */
  current?: number;
}

/** 任务详情 */
export interface SquadTask {
  /** 任务的编号 */
  code?: string;
  /** 活动描述/标题 */
  title?: string;
  /** 要求达成的阈值 */
  required?: string;
  /** 当前达成进度 */
  current?: string;
  /** 奖励积分 */
  reward?: string;
  /** 积分图片的logo */
  pointIcon?: string;
  /** 当前状态，CREATED-已创建待完成，DONE-已达成 */
  status?: string;
  /**
   * 当期活动的开始时间
   * @format int64
   */
  startTime?: number;
  /**
   * 当期活动的截止时间
   * @format int64
   */
  endTime?: number;
  /** 是否已经贡献过了 */
  isContributed?: boolean;
  /**
   * 上一次contribute的时间戳，isContributed=false时为0
   * @format int64
   */
  lastContributeTime?: number;
  /** 用户是否已经claim过奖励了 */
  isClaimed?: boolean;
}

export interface CampaignSquadTaskDetailResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: CampaignSquadTaskDetailResponseAllOfObj;
}

export interface CampaignSquadTaskDetailResponseAllOfObj {
  /** 任务详情 */
  task?: SquadTask;
  /** 用户的贡献值列表，全量，排序好的数据 */
  contributes?: ContributeItem[];
  /** 我的贡献值，如果用户还没贡献过，则该值为0 */
  myContribute?: string;
  /** 所在战队的信息 */
  squad?: SquadInfo;
}

/** 用户的贡献值列表，全量，排序好的数据 */
export interface ContributeItem {
  /** 用户的handle */
  handle?: string;
  /** 用户的贡献值 */
  contribute?: string;
  /** 用户的id */
  passportId?: string;
}

export interface CampaignRewardTiersResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: CampaignRewardTiersResponseAllOfObj;
}

export interface CampaignRewardTiersResponseAllOfObj {
  /** 服务器当前时间 */
  ts?: string;
  my?: CampaignRewardTiersResponseAllOfObjMy;
  tiers?: CampaignTierItem[];
}

export interface CampaignRewardTiersResponseAllOfObjMy {
  /** @format int32 */
  tierNumber?: number;
  tierCode?: string;
  tierName?: string;
  unlock?: boolean;
  tireLocked?: boolean;
}

export interface CampaignTierItem {
  /** @format int32 */
  tierNumber?: number;
  tierCode?: string;
  tierName?: string;
  /** @format int64 */
  allocationCap?: number;
  /** @format int64 */
  fcfsLockedCount?: number;
  /** @format int64 */
  tierLockedCount?: number;
  /** 奖励展示类型（可选），例如 LOTTERY_ONLY */
  rewardType?: string;
  rewards?: CampaignTierRewardItem[];
}

export interface CampaignTierRewardItem {
  /** 奖励类型，TOKEN / LOTTERY_TICKET */
  type?: string;
  /** 奖励符号 */
  symbol?: string;
  /** 奖励数量（TOKEN 场景） */
  amount?: string;
  /** 抽奖券编码（LOTTERY_TICKET 场景） */
  ticketCode?: string;
}

export interface CampaignOverviewResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: CampaignOverviewResponseAllOfObj;
}

export interface CampaignOverviewResponseAllOfObj {
  /** 服务器当前时间 */
  ts?: string;
  participation?: CampaignOverviewResponseAllOfObjParticipation;
  /** 我的档位 FCFS 池是否已耗尽 */
  myTierPoolFcfsExhausted?: boolean;
  prizes?: CampaignOverviewResponseAllOfObjPrizes;
}

export interface CampaignOverviewResponseAllOfObjParticipation {
  joined?: boolean;
  /** @format double */
  yield?: number;
  tierName?: string;
  tierCode?: string;
  /** @format int32 */
  tierNumber?: number;
  unlock?: boolean;
  tireLocked?: boolean;
}

export interface CampaignOverviewResponseAllOfObjPrizes {
  currentTier?: CampaignTierItem;
  nextTier?: CampaignTierItem;
}

export interface CampaignLuckyDrawResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: CampaignLuckyDrawResponseAllOfObj;
}

export interface CampaignLuckyDrawResponseAllOfObj {
  /** 服务器当前时间 */
  ts?: string;
  title?: string;
  /** 抽奖开奖时间 */
  drawAt?: string;
  stats?: CampaignLuckyDrawResponseAllOfObjStats;
  instructions?: string[];
}

export interface CampaignLuckyDrawResponseAllOfObjStats {
  /** 奖池展示文案 */
  totalPrize?: string;
  /** @format int64 */
  yourTickets?: number;
  /** @format int64 */
  globalEntries?: number;
  /** @format int64 */
  totalWinners?: number;
}

export interface CampaignLuckyWinningListResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: CampaignLuckyWinningListResponseAllOfObj;
}

export interface CampaignLuckyWinningListResponseAllOfObj {
  subtitle?: string;
  updatedAt?: string;
  list?: CampaignLuckyWinningListResponseAllOfObjList[];
}

export interface CampaignLuckyWinningListResponseAllOfObjList {
  /** @format int32 */
  rank?: number;
  handle?: string;
  rewardAmount?: string;
  rewardSymbol?: string;
}

export interface CampaignLadderResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: CampaignLadderResponseAllOfObj;
}

export interface CampaignLadderResponseAllOfObj {
  /** 分页参数 */
  nextToken?: string;
  /**
   * 总条数
   * @format int64
   */
  totalCount?: number;
  myLadder?: CampaignLadderVO;
  ladders?: CampaignLadderVO[];
}

export interface CampaignLadderVO {
  passportId?: string;
  handle?: string;
  /** @format int32 */
  rank?: number;
  /** @format double */
  point?: number;
}

export interface CampaignInviteVO {
  passportId?: string;
  handle?: string;
  /** @format int64 */
  inviteTime?: number;
  /** @format double */
  point?: number;
  /** 是否有效 */
  isQualified?: boolean;
  /**
   * 被邀请人的档位数值
   * @format int32
   */
  inviteeYield?: number;
  /** 被邀请人的档位编码 */
  inviteeTierCode?: string;
  /** 被邀请人的档位名称 */
  inviteeTierName?: string;
  /** 被邀请人的钱包地址快照 */
  inviteeWalletAddress?: string;
  /** 记录创建时间（ISO-8601） */
  createdAt?: string;
}

export interface CampaignInvitesResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: CampaignInvitesResponseAllOfObj;
}

export interface CampaignInvitesResponseAllOfObj {
  /** 分页参数 */
  nextToken?: string;
  /**
   * 总邀请人数
   * @format int64
   */
  totalInviteeCount?: number;
  /** 邀请累计获得奖励 */
  totalInviteRewardAmount?: string;
  list?: CampaignInviteVO[];
}

export interface CampaignInviteTierStatsResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: CampaignInviteTierStatsResponseAllOfObj;
}

export interface CampaignInviteTierStatsResponseAllOfObj {
  /** 服务器当前时间 */
  ts?: string;
  tierStats?: CampaignInviteTierStatsResponseAllOfObjTierStats[];
  /** 邀请规则说明 */
  inviteRule?: string;
}

export interface CampaignInviteTierStatsResponseAllOfObjTierStats {
  /** @format int32 */
  tierNumber?: number;
  tierCode?: string;
  tierName?: string;
  inviteRewardAmountTotal?: string;
}

/** 签名结果 */
export interface SignInfo {
  signature?: string;
  /** @format int64 */
  validityStartTimestamp?: number;
  /** @format int64 */
  validityEndTimestamp?: number;
}

export interface SignResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  /** 签名结果 */
  obj?: SignInfo;
}

export interface ThirdBindingsInfoInner {
  /** 第三方平台名称 */
  platform: string;
  /** 绑定状态 0-未绑定 1-已绑定 */
  status: string;
  /** 授权地址 */
  connectUrl: string;
  /** 社交账号名称 */
  socialHandleName: string;
  /** 社交账号头像URL */
  socialProfileImage: string;
}

export interface ThirdBindingsResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: ThirdBindingsInfoInner[];
}

export interface Challenge {
  /** 密钥 */
  text?: string;
}

export interface ChallengeResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: Challenge;
}

export interface TeamRemoveResponse {
  /** 团队id */
  teamId?: string;
  /** 被移除用户id */
  removedUserId?: string;
  /** 移除操作人id */
  removedBy?: string;
  /**
   * 移除时间戳，单位毫秒
   * @format int64
   */
  removedAt?: number;
  /**
   * 成功移除成员数量
   * @format int32
   */
  removedSuccessCount?: number;
  /** 移除原因 */
  reason?: string;
}

export interface WebResultRemoveMemberResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: TeamRemoveResponse;
}

export interface TeamLeaveResponse {
  /** 团队id */
  teamId?: string;
  /** 用户id */
  userId?: string;
  /** 离开时间 */
  leftAt?: string;
  /**
   * 冷静期结束时间
   * @format int64
   */
  coolingPeriodEnd?: number;
  /** 是否在冷静期内 */
  coolingPeriodApplied?: boolean;
}

export interface WebResultLeaveTeamResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: TeamLeaveResponse;
}

export interface MyCampaignListItemDTO {
  source: "APPLICATION" | "CAMPAIGN_ADVERTISER";
  id: string;
  name?: string;
  /** @format int64 */
  date?: number;
  status: string;
  budget?: string;
  /** @format int64 */
  spent?: number;
}

export interface MyCampaignPageResultDTO {
  content: MyCampaignListItemDTO[];
  /**
   * 当前 passport 下处于 Pending Review（PENDING_REVIEW）的申请数量，供列表页 Banner 使用。
   * @format int64
   */
  totalPending: number;
  /** @format int64 */
  total: number;
  /** @format int32 */
  offset: number;
  /** @format int32 */
  size: number;
}

export interface MyCampaignPageResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: MyCampaignPageResultDTO;
}

export interface TrendPointDTO {
  /** @format int64 */
  bucketStart: number;
  /** @format int64 */
  verifiedActions: number;
}

export interface QuestTrendSeriesDTO {
  questCode: string;
  questName?: string;
  actions: TrendPointDTO[];
}

export interface QuestPerformanceItemDTO {
  questCode: string;
  questName?: string;
  /** @format int64 */
  actions: number;
  /** @format double */
  cpa?: number;
}

/** Total / By Quest 两套序列。 */
export interface ActionsTrendDTO {
  total: TrendPointDTO[];
  byQuest: QuestTrendSeriesDTO[];
}

export interface DashboardStatsDTO {
  /** @format int64 */
  verifiedActions?: number;
  /** @format int64 */
  verifiedActionsToday?: number;
  /** @format double */
  effectiveCpa?: number;
  budgetAllocated?: string;
  /** @format int64 */
  totalSpend?: number;
  /** @format int64 */
  refunded?: number;
  /** @format int64 */
  activeUsers?: number;
  /** @format int64 */
  totalUsers?: number;
  avgActionsPerUser?: string;
}

export interface CampaignDashboardViewDTO {
  campaignId: string;
  campaignName: string;
  status: "APPROVED" | "LIVE" | "SETTLING" | "COMPLETED";
  advertiserName?: string;
  /** @format int64 */
  startTs?: number;
  /** @format int64 */
  endTs?: number;
  /** @format int64 */
  settlingStartedAt?: number;
  stats?: DashboardStatsDTO;
  /** Total / By Quest 两套序列。 */
  actionsTrend?: ActionsTrendDTO;
  questPerformance?: QuestPerformanceItemDTO[];
  refundedAmount?: string;
  /** @format int64 */
  refundedAt?: number;
  refundedTxHash?: string;
}

export interface CampaignDashboardViewResponse {
  success?: boolean;
  code?: string;
  message?: string;
  resultCode?:
    | "SIGNATURE_INVALID"
    | "REFRESH_TOKEN_INVALID"
    | "REPEAT_OPERATION"
    | "PARAMS_ILLEGAL"
    | "HANDLE_NAME_EXISTS"
    | "SENSITIVE_WORDS"
    | "BADGE_NOT_FOUND"
    | "EVM_ADDRESS_ILLEGAL"
    | "USER_WALLET_NOT_FOUND"
    | "FCM_BIND_FAILED"
    | "NO_RESOURCE_PERMISSION"
    | "RESOURCE_NOT_FOUND"
    | "MBTI_ALREADY_SET"
    | "INVALID_MBTI_TYPE"
    | "API_RATE_LIMITING"
    | "ACTIVITY_HAS_ENDED"
    | "OPERATION_FAILED"
    | "UNKNOWN_ERROR";
  obj?: CampaignDashboardViewDTO;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<
  D extends unknown,
  E extends unknown = unknown,
> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "https://api.trex.dev.dipbit.xyz";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title trex api
 * @version 1.0
 * @baseUrl https://api.trex.dev.dipbit.xyz
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  v1 = {
    /**
     * @description 修改战队信息
     *
     * @tags Team
     * @name UpdateTeam
     * @summary Update team
     * @request PUT:/v1/teams/update
     */
    updateTeam: (data: UpdateTeamRequest, params: RequestParams = {}) =>
      this.request<WebResultUpdateTeamResponse, any>({
        path: `/v1/teams/update`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 更新用户社媒隐私设置
     *
     * @tags Team
     * @name UpdateSocialPrivacy
     * @summary Update social media privacy
     * @request PUT:/v1/teams/update/social-privacy
     */
    updateSocialPrivacy: (
      query: {
        /** 社媒隐私状态：public(公开)/teamOnly(仅队友可见)/private(私密) */
        socialPrivacy: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<WebResultUpdateSocialPrivacyResponse, any>({
        path: `/v1/teams/update/social-privacy`,
        method: "PUT",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 用户开始观看视频时创建新的会话，返回会话ID及相关奖励信息
     *
     * @tags Video
     * @name InitVideoSession
     * @summary 初始化视频观看会话
     * @request POST:/v1/video/session/init
     * @secure
     */
    initVideoSession: (
      data: VideoSessionInitRequest,
      params: RequestParams = {},
    ) =>
      this.request<VideoSessionInitResponse, VideoSessionInitResponse>({
        path: `/v1/video/session/init`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 上报事件数据
     *
     * @tags Video
     * @name ReportEvents
     * @summary 上报事件数据
     * @request POST:/v1/video/events/report
     * @secure
     */
    reportEvents: (
      data: VideoEventsReportRequest,
      params: RequestParams = {},
    ) =>
      this.request<EventDataDetails, any>({
        path: `/v1/video/events/report`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 创建新团队，支持设置背景图
     *
     * @tags Team
     * @name CreateTeam
     * @summary Create team
     * @request POST:/v1/teams
     */
    createTeam: (data: CreateTeamRequest, params: RequestParams = {}) =>
      this.request<WebResultCreateTeamResponse, any>({
        path: `/v1/teams`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 修改战队类型
     *
     * @tags Team
     * @name UpdateTeamType
     * @summary Update team
     * @request POST:/v1/teams/update/type
     */
    updateTeamType: (
      query: {
        /** team type to update to */
        targetType: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<WebResultUpdateTeamResponse, any>({
        path: `/v1/teams/update/type`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 加入团队，支持通过邀请码或直接指定团队ID
     *
     * @tags Team
     * @name JoinTeam
     * @summary Join team
     * @request POST:/v1/teams/join
     */
    joinTeam: (data: JoinTeamRequest, params: RequestParams = {}) =>
      this.request<WebResultJoinTeamResponse, any>({
        path: `/v1/teams/join`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Activity
     * @name TaskSocialEvent
     * @summary 社交事件
     * @request POST:/v1/task/socialEvent
     * @secure
     */
    taskSocialEvent: (
      data: TaskSocialEventRequest,
      params: RequestParams = {},
    ) =>
      this.request<TaskSocialEventResponse, any>({
        path: `/v1/task/socialEvent`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 同步任务状态
     *
     * @tags PersonaS2S
     * @name SyncPersonaQuestsStatus
     * @summary 同步任务状态
     * @request POST:/v1/s2s/personas/quests/status
     */
    syncPersonaQuestsStatus: (
      data: PersonaQuestsStatusRequest,
      params: RequestParams = {},
    ) =>
      this.request<PersonaQuestsStatusResponse, any>({
        path: `/v1/s2s/personas/quests/status`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 删除社媒信息
     *
     * @tags Customer
     * @name UnbindSocialInfo
     * @summary 删除社媒信息
     * @request POST:/v1/s2s/customers/unbindSocialInfo
     * @secure
     */
    unbindSocialInfo: (
      data: UnbindSocialInfoRequest,
      params: RequestParams = {},
    ) =>
      this.request<UnBindSocialInfoResponse, any>({
        path: `/v1/s2s/customers/unbindSocialInfo`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 保存社媒信息
     *
     * @tags Customer
     * @name BindSocialInfo
     * @summary 保存社媒信息
     * @request POST:/v1/s2s/customers/bindSocialInfo
     * @secure
     */
    bindSocialInfo: (data: BindSocialInfoRequest, params: RequestParams = {}) =>
      this.request<BindSocialInfoResponse, any>({
        path: `/v1/s2s/customers/bindSocialInfo`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 广告主加入活动
     *
     * @tags Campaign
     * @name JoinCampaign
     * @summary 广告主加入活动
     * @request POST:/v1/s2s/campaigns/advertisers/{campaignAdvertiserId}/join/{passportId}
     * @secure
     */
    joinCampaign: (
      campaignAdvertiserId: string,
      passportId: string,
      params: RequestParams = {},
    ) =>
      this.request<JoinCampaign200Response, any>({
        path: `/v1/s2s/campaigns/advertisers/${campaignAdvertiserId}/join/${passportId}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 恐龙收集奖励
     *
     * @tags Rexy
     * @name RexyRewardCollect
     * @summary 恐龙收集奖励
     * @request POST:/v1/rexys/reward/collect
     * @secure
     */
    rexyRewardCollect: (
      data: RexyRewardCollectRequest,
      params: RequestParams = {},
    ) =>
      this.request<RewardCollectResponse, any>({
        path: `/v1/rexys/reward/collect`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 领取积分奖励
     *
     * @tags Rexy
     * @name RexyClaim
     * @summary 领取积分奖励
     * @request POST:/v1/rexys/claim
     * @secure
     */
    rexyClaim: (data: RexyClaimRequest, params: RequestParams = {}) =>
      this.request<ClaimResponse, any>({
        path: `/v1/rexys/claim`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 生成交易业务id
     *
     * @tags Rexy
     * @name RexyClaimBuild
     * @summary 生成交易业务id
     * @request POST:/v1/rexys/claim/build/{basketType}
     * @secure
     */
    rexyClaimBuild: (
      basketType: string,
      query?: {
        /** 钱包地址 */
        address?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ClaimBuildResponse, any>({
        path: `/v1/rexys/claim/build/${basketType}`,
        method: "POST",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 从已绑定钱包中选择全局奖励钱包
     *
     * @tags Passport
     * @name SetRewardWallet
     * @summary 设置全局奖励钱包
     * @request POST:/v1/passport/wallet/reward
     */
    setRewardWallet: (
      data: SetRewardWalletRequest,
      params: RequestParams = {},
    ) =>
      this.request<SetRewardWalletResponse, any>({
        path: `/v1/passport/wallet/reward`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 绑定钱包
     *
     * @tags Auth
     * @name BindWallet
     * @summary 绑定钱包
     * @request POST:/v1/passport/wallet/bind
     */
    bindWallet: (data: BindWalletRequest, params: RequestParams = {}) =>
      this.request<BindWalletResponse, any>({
        path: `/v1/passport/wallet/bind`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 保存用户handleName信息
     *
     * @tags Passport
     * @name SetHandleName
     * @summary 保存用户handleName信息
     * @request POST:/v1/passport/setHandleName
     */
    setHandleName: (
      query: {
        /** handleName */
        handleName: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SetHandleNameResponse, any>({
        path: `/v1/passport/setHandleName`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 查询用户是否符合mint条件
     *
     * @tags Passport
     * @name EligibleGet
     * @summary 查询用户是否符合mint条件
     * @request GET:/v1/passport/nft/eligible
     * @secure
     */
    eligibleGet: (params: RequestParams = {}) =>
      this.request<EligibleGetResponse, any>({
        path: `/v1/passport/nft/eligible`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 添加用户到mint名单
     *
     * @tags Passport
     * @name EligiblePost
     * @summary 添加用户到mint名单
     * @request POST:/v1/passport/nft/eligible
     * @secure
     */
    eligiblePost: (data: EligiblePostRequest, params: RequestParams = {}) =>
      this.request<EligiblePostResponse, any>({
        path: `/v1/passport/nft/eligible`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 设置用户的MBTI人格类型，只能设置一次
     *
     * @tags Passport
     * @name UpdateMbti
     * @summary 设置用户MBTI人格类型
     * @request POST:/v1/passport/mbti
     */
    updateMbti: (data: UpdateMbtiRequest, params: RequestParams = {}) =>
      this.request<UpdateMbtiResponse, any>({
        path: `/v1/passport/mbti`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Landing Page "Contact Sales" 表单提交，保存意向记录并发送邮件通知。无需登录。
     *
     * @tags OnboardingApplication
     * @name SubmitLandingContact
     * @summary 提交 Landing Page 合作意向
     * @request POST:/v1/growth/onboarding/landing-contacts
     */
    submitLandingContact: (
      data: SubmitLandingContactRequest,
      params: RequestParams = {},
    ) =>
      this.request<SubmitLandingContactResponse, any>({
        path: `/v1/growth/onboarding/landing-contacts`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 创建一个新的 onboarding 申请单。intent=DRAFT 时游客可调；intent=SUBMIT_PAYMENT/SUBMIT_SALES 时需登录。
     *
     * @tags OnboardingApplication
     * @name CreateApplication
     * @summary 创建 application
     * @request POST:/v1/growth/onboarding/applications
     * @secure
     */
    createApplication: (
      data: CreateOrUpdateApplicationRequest,
      params: RequestParams = {},
    ) =>
      this.request<CampaignApplicationResponse, any>({
        path: `/v1/growth/onboarding/applications`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 根据 applicationId 读取一份申请单。游客可读（公开 ID 时）。
     *
     * @tags OnboardingApplication
     * @name GetApplicationById
     * @summary 读取 application
     * @request GET:/v1/growth/onboarding/applications/{id}
     * @secure
     */
    getApplicationById: (id: string, params: RequestParams = {}) =>
      this.request<CampaignApplicationResponse, any>({
        path: `/v1/growth/onboarding/applications/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 覆盖式更新申请单（intent=DRAFT/SUBMIT_PAYMENT/SUBMIT_SALES）。SUBMIT_* 必填 JWT。
     *
     * @tags OnboardingApplication
     * @name UpdateApplication
     * @summary 更新 application
     * @request POST:/v1/growth/onboarding/applications/{id}
     * @secure
     */
    updateApplication: (
      id: string,
      data: CreateOrUpdateApplicationRequest,
      params: RequestParams = {},
    ) =>
      this.request<CampaignApplicationResponse, any>({
        path: `/v1/growth/onboarding/applications/${id}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 项目方app/服务端通过s2s接口发送event事件，后端根据需要进行业务解析和处理
     *
     * @tags Events
     * @name ReportEvents1
     * @summary 任务上报接口
     * @request POST:/v1/events/{advertiserId}
     * @secure
     */
    reportEvents1: (
      advertiserId: string,
      data: EventReportRequest,
      params: RequestParams = {},
    ) =>
      this.request<EventReportResponse, any>({
        path: `/v1/events/${advertiserId}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Upload a social media post
     *
     * @tags Customer
     * @name PlatformSocialUpload
     * @summary /customers/platform/social/upload
     * @request POST:/v1/customers/social/upload
     */
    platformSocialUpload: (
      data: SocialUploadRequest,
      params: RequestParams = {},
    ) =>
      this.request<SocialUploadResponse, any>({
        path: `/v1/customers/social/upload`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 更新用户授权隐私状态
     *
     * @tags Customer
     * @name ReversePrivacyAuth
     * @summary 更新用户授权隐私状态
     * @request POST:/v1/customers/privacy/reverseAuth
     */
    reversePrivacyAuth: (
      data: ReversePrivacyAuth,
      params: RequestParams = {},
    ) =>
      this.request<ReservePrivacyAuthResponse, any>({
        path: `/v1/customers/privacy/reverseAuth`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description query notify switch
     *
     * @tags Notification
     * @name QueryNotifySwitch
     * @summary query notify switch
     * @request GET:/v1/customers/notify/switch
     */
    queryNotifySwitch: (params: RequestParams = {}) =>
      this.request<NotifySwitchResponse, any>({
        path: `/v1/customers/notify/switch`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description set notify switch
     *
     * @tags Notification
     * @name UpdateNotifySwitch
     * @summary set notify switch
     * @request POST:/v1/customers/notify/switch
     */
    updateNotifySwitch: (
      data: UpdateNotifySwitchRequest,
      params: RequestParams = {},
    ) =>
      this.request<UpdateNotifySwitchResponse, any>({
        path: `/v1/customers/notify/switch`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 邀请绑定
     *
     * @tags Customer
     * @name BindInvite
     * @summary 邀请绑定
     * @request POST:/v1/customers/invites/bind
     * @secure
     */
    bindInvite: (data: InviteBindRequest, params: RequestParams = {}) =>
      this.request<InviteBindResponse, any>({
        path: `/v1/customers/invites/bind`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 创建新团队，支持设置背景图
     *
     * @tags Notification
     * @name FcmBind
     * @summary bind fcm token
     * @request POST:/v1/customers/fcm/bind
     */
    fcmBind: (data: FcmBindRequest, params: RequestParams = {}) =>
      this.request<FcmBindResponse, any>({
        path: `/v1/customers/fcm/bind`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description join the waitList from officialWebsite
     *
     * @tags Customer
     * @name AddWaitList
     * @summary /customers/addWaitList
     * @request POST:/v1/customers/addWaitList
     */
    addWaitList: (data: AddWaitListRequest, params: RequestParams = {}) =>
      this.request<AddWaitListResponse, any>({
        path: `/v1/customers/addWaitList`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description join the wait developer List
     *
     * @tags Customer
     * @name AddWaitDeveloperList
     * @summary /customers/addWaitDeveloperList
     * @request POST:/v1/customers/addDeveloperWaitList
     */
    addWaitDeveloperList: (
      data: AddWaitDeveloperListRequest,
      params: RequestParams = {},
    ) =>
      this.request<AddWaitDeveloperListResponse, any>({
        path: `/v1/customers/addDeveloperWaitList`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 用于上传文件，返回文件名称和文件路径
     *
     * @tags Customer
     * @name AddWaitListUpload
     * @summary 上传文件
     * @request POST:/v1/customers/addDeveloperWaitList/upload
     */
    addWaitListUpload: (
      data: {
        /**
         * 需要上传的文件
         * @format binary
         */
        file?: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<AddDeveloperWaitListUploadResponse, any>({
        path: `/v1/customers/addDeveloperWaitList/upload`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * @description join the wait creator List
     *
     * @tags Customer
     * @name AddWaitCreatorList
     * @summary /customers/addWaitCreatorList
     * @request POST:/v1/customers/addCreateWaitList
     */
    addWaitCreatorList: (
      data: AddWaitCreatorListRequest,
      params: RequestParams = {},
    ) =>
      this.request<AddWaitCreatorListResponse, any>({
        path: `/v1/customers/addCreateWaitList`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 获取链上 claim 所需参数
     *
     * @tags Campaign
     * @name GetCampaignReward
     * @summary 获取活动奖励 Claim 参数
     * @request POST:/v1/campaigns/{campaignId}/reward
     */
    getCampaignReward: (campaignId: string, params: RequestParams = {}) =>
      this.request<CampaignClaimRewardResponse, any>({
        path: `/v1/campaigns/${campaignId}/reward`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description 用户领取已达成战队任务的积分奖励
     *
     * @tags Campaign Squad Task
     * @name ClaimCampaignSquadReward
     * @summary 领取战队任务奖励
     * @request POST:/v1/campaigns/advertisers/{campaignAdvertiserId}/squads/rewards/{code}
     */
    claimCampaignSquadReward: (
      campaignAdvertiserId: string,
      code: string,
      params: RequestParams = {},
    ) =>
      this.request<CampaignSquadRewardResponse, any>({
        path: `/v1/campaigns/advertisers/${campaignAdvertiserId}/squads/rewards/${code}`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description 用户点击CONTRIBUTE按钮，触发检查用户贡献并加入战队任务进度中
     *
     * @tags Campaign Squad Task
     * @name ContributeCampaignSquadTask
     * @summary 贡献战队任务
     * @request POST:/v1/campaigns/advertisers/{campaignAdvertiserId}/squads/contributes/{code}
     */
    contributeCampaignSquadTask: (
      campaignAdvertiserId: string,
      code: string,
      params: RequestParams = {},
    ) =>
      this.request<CampaignSquadContributeResponse, any>({
        path: `/v1/campaigns/advertisers/${campaignAdvertiserId}/squads/contributes/${code}`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description 提交孵化并锁定当前档位。 请求体中的 `yield` 须与上次 overview 等接口返回给前端的「将要锁定的等级」一致，用于校验提交锁定前用户档位是否已变化。
     *
     * @tags Campaign
     * @name HatchCampaignLevel
     * @summary 锁定孵化档位
     * @request POST:/v1/campaigns/advertisers/{campaignAdvertiserId}/hatch
     */
    hatchCampaignLevel: (
      campaignAdvertiserId: string,
      data: HatchCampaignLevelRequest,
      params: RequestParams = {},
    ) =>
      this.request<CampaignHatchResponse, any>({
        path: `/v1/campaigns/advertisers/${campaignAdvertiserId}/hatch`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description third platform authorize
     *
     * @tags Auth
     * @name ThirdAuthorize
     * @summary /customer/auth/third/authorize
     * @request POST:/v1/auth/third/authorize
     * @secure
     */
    thirdAuthorize: (data: ThirdAuthorizeRequest, params: RequestParams = {}) =>
      this.request<ThirdAuthorizeResponse, any>({
        path: `/v1/auth/third/authorize`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 刷新
     *
     * @tags Auth
     * @name RefreshAccessToken
     * @summary 刷新accessToken
     * @request POST:/v1/auth/refresh
     */
    refreshAccessToken: (
      query?: {
        /** accessToken */
        accessToken?: string;
        /** refreshToken */
        refreshToken?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AccessTokenResponse, any>({
        path: `/v1/auth/refresh`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 登录
     *
     * @tags Auth
     * @name QrAuthLogin
     * @summary 登录
     * @request POST:/v1/auth/qr/login
     */
    qrAuthLogin: (data: LoginRequest, params: RequestParams = {}) =>
      this.request<AccessTokenResponse, any>({
        path: `/v1/auth/qr/login`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 登出
     *
     * @tags Auth
     * @name Logout
     * @summary 登出
     * @request POST:/v1/auth/logout
     * @secure
     */
    logout: (params: RequestParams = {}) =>
      this.request<LogoutResponse, any>({
        path: `/v1/auth/logout`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 登录
     *
     * @tags Auth
     * @name AuthLogin
     * @summary 登录
     * @request POST:/v1/auth/login
     */
    authLogin: (data: LoginRequest, params: RequestParams = {}) =>
      this.request<AccessTokenResponse, any>({
        path: `/v1/auth/login`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 查询ntf数量
     *
     * @tags Tx
     * @name NftHold
     * @summary 查询nft数量
     * @request GET:/v1/tx/nft/hold
     * @secure
     */
    nftHold: (
      query: {
        /**
         * nft类型
         * @default "trex"
         */
        code: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<NftHoldResponse, any>({
        path: `/v1/tx/nft/hold`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 水龙头领水
     *
     * @tags Tx
     * @name FaucetDrip
     * @summary 水龙头领水
     * @request GET:/v1/tx/faucet
     */
    faucetDrip: (
      query: {
        /** 领取水的钱包地址 */
        address: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<FaucetDripResponse, any>({
        path: `/v1/tx/faucet`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 查询战队的邀请码
     *
     * @tags Team
     * @name GetPassportTeamCode
     * @summary 用户的战队邀请码
     * @request GET:/v1/teams/team/code
     */
    getPassportTeamCode: (
      query?: {
        /** 战队id */
        teamId?: string;
        /** 个人code */
        code?: string;
        /**
         * 业务场景
         * @default "TREX_ANCHOR_TEAM"
         */
        scene?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TeamCodeResponse, any>({
        path: `/v1/teams/team/code`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 获取团队详情，包含已解锁的徽章信息
     *
     * @tags Team
     * @name GetTeamDetail
     * @summary Get team detail
     * @request GET:/v1/s2s/teams/detail/{userId}
     */
    getTeamDetail: (userId: string, params: RequestParams = {}) =>
      this.request<WebResultTeamDetailResponse, any>({
        path: `/v1/s2s/teams/detail/${userId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description third platform bindInfo
     *
     * @tags Customer
     * @name QueryBySocialInfo
     * @summary customers/queryBySocialInfo
     * @request GET:/v1/s2s/customers/queryBySocialInfo
     * @secure
     */
    queryBySocialInfo: (
      query: {
        /** platform */
        platform: string;
        /** passportId */
        passportId?: string;
        /** socialUserId */
        socialUserId?: string;
        /** socialHandleName */
        socialHandleName?: string;
        /** socialEmail */
        socialEmail?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<QueryBySocialInfoResponse, any>({
        path: `/v1/s2s/customers/queryBySocialInfo`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 查询当前用户邀请信息
     *
     * @tags Customer
     * @name InviteByCid
     * @summary 查询当前用户邀请信息
     * @request GET:/v1/s2s/customers/invites/me
     * @secure
     */
    inviteByCid: (
      query: {
        cid: string;
        /** 邀请类型(bindInviteCode, campaign), 默认为 bindInviteCode */
        type?: string;
        /** 当 type 为 campaign，传 campaignAdvertiserId */
        bizId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<InviteInfoResponse, any>({
        path: `/v1/s2s/customers/invites/me`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 获取指定Token资产信息
     *
     * @tags Asset
     * @name GetAssetToken
     * @summary Get token detail
     * @request GET:/v1/s2s/asset/token/{userId}
     */
    getAssetToken: (
      userId: string,
      query: {
        chainId: string;
        tokenAddress: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AssetTokenResponse, any>({
        path: `/v1/s2s/asset/token/${userId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 获取指定Token资产信息
     *
     * @tags Asset
     * @name GetAssetTokenDexPair
     * @summary Get token detail
     * @request GET:/v1/s2s/asset/token/dexpair/{userId}
     */
    getAssetTokenDexPair: (
      userId: string,
      query: {
        chainId: string;
        baseTokenAddress: string;
        quoteTokenAddress: string;
        pairAddress?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AssetTokenResponse, any>({
        path: `/v1/s2s/asset/token/dexpair/${userId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 获取NFT资产信息
     *
     * @tags Asset
     * @name GetAssetNft
     * @summary Get NFT detail
     * @request GET:/v1/s2s/asset/nft/{userId}
     */
    getAssetNft: (
      userId: string,
      query: {
        chainId: string;
        contractAddress: string;
        /** @format int64 */
        minHoldingTimestamp: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<AssetNFTResponse, any>({
        path: `/v1/s2s/asset/nft/${userId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 获取NFT资产信息
     *
     * @tags Asset
     * @name GetAssetNftSummary
     * @summary Get NFT detail
     * @request GET:/v1/s2s/asset/nft/summary/{userId}
     */
    getAssetNftSummary: (
      userId: string,
      query: {
        chainId: string;
        contractAddress: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AssetNFTResponse, any>({
        path: `/v1/s2s/asset/nft/summary/${userId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 获取领取资产徽章信息
     *
     * @tags Asset
     * @name GetAssetBadge
     * @summary Get Asset Badge
     * @request GET:/v1/s2s/asset/badge/{userId}
     */
    getAssetBadge: (
      userId: string,
      query?: {
        statusEnum?: string;
        strategy?: string;
        rarity?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AssetBadgeResponse, any>({
        path: `/v1/s2s/asset/badge/${userId}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 查询最新恐龙蛋
     *
     * @tags Rexy
     * @name RexyRewardLast
     * @summary 查询最新恐龙蛋
     * @request GET:/v1/rexys/reward/last
     * @secure
     */
    rexyRewardLast: (
      query: {
        /** 平台，可选值：X 或 YouTube */
        platform: string;
        /** 内容id */
        content_id?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<RexyRewardLastResponse, any>({
        path: `/v1/rexys/reward/last`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 查询当前用户宠物信息
     *
     * @tags Rexy
     * @name Rexy
     * @summary 查询当前用户宠物信息
     * @request GET:/v1/rexys/me
     * @secure
     */
    rexy: (params: RequestParams = {}) =>
      this.request<RexyInfoResponse, any>({
        path: `/v1/rexys/me`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 查询恐龙列表
     *
     * @tags Rexy
     * @name Rexys
     * @summary 查询恐龙列表
     * @request GET:/v1/rexys/avatar
     * @secure
     */
    rexys: (params: RequestParams = {}) =>
      this.request<RexysResponse, any>({
        path: `/v1/rexys/avatar`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description query personas
     *
     * @tags Persona
     * @name QueryPersonas
     * @summary query personas
     * @request GET:/v1/personas
     */
    queryPersonas: (
      query: {
        /** 父节点code */
        parentCode: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PersonasResponse, any>({
        path: `/v1/personas`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description persona stats
     *
     * @tags Persona
     * @name PersonaStats
     * @summary persona stats
     * @request GET:/v1/personas/stats
     */
    personaStats: (params: RequestParams = {}) =>
      this.request<PersonaStatsResponse, any>({
        path: `/v1/personas/stats`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description persona feature
     *
     * @tags Persona
     * @name PersonaFeature
     * @summary persona feature
     * @request GET:/v1/personas/feature
     */
    personaFeature: (params: RequestParams = {}) =>
      this.request<PersonaFeatureResponse, any>({
        path: `/v1/personas/feature`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description 返回用户的passport基本信息，包括customerId、created时间和handleName
     *
     * @tags Passport
     * @name GetPassportInfo
     * @summary 查询用户passport信息
     * @request GET:/v1/passport/me
     */
    getPassportInfo: (params: RequestParams = {}) =>
      this.request<PassportResponse, any>({
        path: `/v1/passport/me`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description 返回用户的passportConnect钱包连接信息
     *
     * @tags Passport
     * @name GetPassportConnect
     * @summary 查询用户passportConnect钱包连接信息
     * @request GET:/v1/passport/connect
     */
    getPassportConnect: (
      query?: {
        /** 额外返回的钱包类型 */
        type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<PassportConnectResponse, any>({
        path: `/v1/passport/connect`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 查询未读消息通知列表
     *
     * @tags Notice
     * @name GetNotices
     * @summary 查询未读消息通知列表
     * @request GET:/v1/notice
     * @secure
     */
    getNotices: (
      query?: {
        /**
         * 最后一次拉取通知的时间
         * @format int64
         * @default 0
         */
        lastFetchNotifyTime?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<NoticeResponse, any>({
        path: `/v1/notice`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 查询新闻列表
     *
     * @tags News
     * @name News
     * @summary 查询新闻列表
     * @request GET:/v1/news
     * @secure
     */
    news: (
      query?: {
        /**
         * 偏移量
         * @format int64
         * @default 0
         */
        offset?: number;
        /**
         * 查询数量
         * @format int64
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<NewsInfoResponse, any>({
        path: `/v1/news`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description discovery events
     *
     * @tags News
     * @name DiscoveryEvents
     * @summary discovery events
     * @request GET:/v1/news/discovery/events
     */
    discoveryEvents: (
      query?: {
        /**
         * 偏移量
         * @format int64
         * @default 0
         */
        offset?: number;
        /**
         * 查询数量
         * @format int64
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<DiscoveryEventsResponse, any>({
        path: `/v1/news/discovery/events`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description discovery blog
     *
     * @tags News
     * @name DiscoveryBlog
     * @summary discovery blog
     * @request GET:/v1/news/dicovery/blog
     */
    discoveryBlog: (
      query?: {
        /**
         * 偏移量
         * @format int64
         * @default 0
         */
        offset?: number;
        /**
         * 查询数量
         * @format int64
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<DiscoveryBlogResponse, any>({
        path: `/v1/news/dicovery/blog`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 查询新闻列表banner
     *
     * @tags News
     * @name Banner
     * @summary 查询新闻banner
     * @request GET:/v1/news/banner
     * @secure
     */
    banner: (params: RequestParams = {}) =>
      this.request<NewsInfoResponse, any>({
        path: `/v1/news/banner`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 获取 payment 配置快照（plans/currencies/recipients/chains）。
     *
     * @tags OnboardingApplication
     * @name GetOnboardingConfigs
     * @summary 获取 onboarding 配置
     * @request GET:/v1/growth/onboarding/configs
     * @secure
     */
    getOnboardingConfigs: (params: RequestParams = {}) =>
      this.request<OnboardingConfigResponse, any>({
        path: `/v1/growth/onboarding/configs`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Customize 时拉全 10 个 audience。游客可调。
     *
     * @tags OnboardingAdvertiser
     * @name ListAudienceSegments
     * @summary 列出全部 audience segments
     * @request GET:/v1/growth/onboarding/audience-segments
     * @secure
     */
    listAudienceSegments: (params: RequestParams = {}) =>
      this.request<AudienceSegmentListResponse, any>({
        path: `/v1/growth/onboarding/audience-segments`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 输入项目 URL 或 X handle，返回项目情报与推荐 audiences。游客可调。
     *
     * @tags OnboardingAdvertiser
     * @name GetAdvertiserIntelligence
     * @summary 项目情报分析
     * @request GET:/v1/growth/onboarding/advertiser-intelligence
     * @secure
     */
    getAdvertiserIntelligence: (
      query: {
        /** 用户输入（X handle） */
        input: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<AnalysisResultResponse, any>({
        path: `/v1/growth/onboarding/advertiser-intelligence`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 查询用户是否同意授权隐私协议
     *
     * @tags Customer
     * @name PrivacyAuth
     * @summary 查询用户是否同意授权隐私协议
     * @request GET:/v1/customers/privacy/auth
     */
    privacyAuth: (params: RequestParams = {}) =>
      this.request<PrivacyAuthResponse, any>({
        path: `/v1/customers/privacy/auth`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Retrieve historical notification messages for the user
     *
     * @tags Notification
     * @name GetNotificationHistory
     * @summary Query notification history messages
     * @request GET:/v1/customers/notify/history/message
     */
    getNotificationHistory: (params: RequestParams = {}) =>
      this.request<NotificationHistoryResponse, any>({
        path: `/v1/customers/notify/history/message`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description 查询当前用户邀请信息
     *
     * @tags Customer
     * @name Invite
     * @summary 查询当前用户邀请信息
     * @request GET:/v1/customers/invites/me
     * @secure
     */
    invite: (
      query?: {
        /** 邀请类型(bindInviteCode, campaign), 默认为 bindInviteCode */
        type?: string;
        /** 当 type 为 campaign，传 campaignAdvertiserId */
        bizId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<InviteInfoResponse, any>({
        path: `/v1/customers/invites/me`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 获取首页banner展示的进行中/预告中的Campaign列表
     *
     * @tags Campaign
     * @name GetCampaigns
     * @summary 获取当前Campaign列表
     * @request GET:/v1/campaigns
     */
    getCampaigns: (params: RequestParams = {}) =>
      this.request<CampaignsResponse, any>({
        path: `/v1/campaigns`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description 获取活动详情页所有静态和动态信息
     *
     * @tags Campaign
     * @name GetAdvertiserDetail
     * @summary 获取Advertiser详情
     * @request GET:/v1/campaigns/advertisers/{campaignAdvertiserId}
     */
    getAdvertiserDetail: (
      campaignAdvertiserId: string,
      params: RequestParams = {},
    ) =>
      this.request<AdvertiserDetailResponse, any>({
        path: `/v1/campaigns/advertisers/${campaignAdvertiserId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description 获取用户可参与的任务及其完成状态。本接口只是用来控制quests任务的组织形式（比如是否分页签，是否分层），具体活动的配置和内容需要调quests的查询活动列表的接口进行查询，然后根据taskId关联。
     *
     * @tags Campaign
     * @name GetCampaignTasks
     * @summary 获取任务列表
     * @request GET:/v1/campaigns/advertisers/{campaignAdvertiserId}/tasks/{parentCode}
     */
    getCampaignTasks: (
      campaignAdvertiserId: string,
      parentCode: string,
      params: RequestParams = {},
    ) =>
      this.request<CampaignTasksResponse, any>({
        path: `/v1/campaigns/advertisers/${campaignAdvertiserId}/tasks/${parentCode}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description 获取当前用户在指定Campaign下的战队任务列表及所在战队信息
     *
     * @tags Campaign Squad Task
     * @name GetCampaignSquadTasks
     * @summary 查询战队任务列表
     * @request GET:/v1/campaigns/advertisers/{campaignAdvertiserId}/squads
     */
    getCampaignSquadTasks: (
      campaignAdvertiserId: string,
      params: RequestParams = {},
    ) =>
      this.request<CampaignSquadTasksResponse, any>({
        path: `/v1/campaigns/advertisers/${campaignAdvertiserId}/squads`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description 获取指定战队任务的详细信息，包括成员贡献列表
     *
     * @tags Campaign Squad Task
     * @name GetCampaignSquadTaskDetail
     * @summary 查询战队任务详情
     * @request GET:/v1/campaigns/advertisers/{campaignAdvertiserId}/squads/{code}
     */
    getCampaignSquadTaskDetail: (
      campaignAdvertiserId: string,
      code: string,
      params: RequestParams = {},
    ) =>
      this.request<CampaignSquadTaskDetailResponse, any>({
        path: `/v1/campaigns/advertisers/${campaignAdvertiserId}/squads/${code}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description 返回全档位奖励信息和我的当前档位
     *
     * @tags Campaign
     * @name GetCampaignRewardTiers
     * @summary 获取活动档位奖励
     * @request GET:/v1/campaigns/advertisers/{campaignAdvertiserId}/reward-tiers
     */
    getCampaignRewardTiers: (
      campaignAdvertiserId: string,
      params: RequestParams = {},
    ) =>
      this.request<CampaignRewardTiersResponse, any>({
        path: `/v1/campaigns/advertisers/${campaignAdvertiserId}/reward-tiers`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description 返回参与状态、当前/下一档奖励及 FCFS 占位信息
     *
     * @tags Campaign
     * @name GetCampaignOverview
     * @summary 获取用户活动概览
     * @request GET:/v1/campaigns/advertisers/{campaignAdvertiserId}/me/overview
     */
    getCampaignOverview: (
      campaignAdvertiserId: string,
      params: RequestParams = {},
    ) =>
      this.request<CampaignOverviewResponse, any>({
        path: `/v1/campaigns/advertisers/${campaignAdvertiserId}/me/overview`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description 查询 Lucky Draw 页面的倒计时、统计和说明文案
     *
     * @tags Campaign
     * @name GetCampaignLuckyDraw
     * @summary 获取 Lucky Draw 聚合信息
     * @request GET:/v1/campaigns/advertisers/{campaignAdvertiserId}/lucky-draw
     */
    getCampaignLuckyDraw: (
      campaignAdvertiserId: string,
      params: RequestParams = {},
    ) =>
      this.request<CampaignLuckyDrawResponse, any>({
        path: `/v1/campaigns/advertisers/${campaignAdvertiserId}/lucky-draw`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description 查询 Lucky Draw 中奖名单（后端 OSS 回源）
     *
     * @tags Campaign
     * @name GetCampaignLuckyWinningList
     * @summary 获取中奖名单
     * @request GET:/v1/campaigns/advertisers/{campaignAdvertiserId}/luckly-winning-list
     */
    getCampaignLuckyWinningList: (
      campaignAdvertiserId: string,
      params: RequestParams = {},
    ) =>
      this.request<CampaignLuckyWinningListResponse, any>({
        path: `/v1/campaigns/advertisers/${campaignAdvertiserId}/luckly-winning-list`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description Campaign 排行榜(结算后)
     *
     * @tags Campaign
     * @name GetCampaignLadder
     * @summary Campaign 排行榜(结算后)
     * @request GET:/v1/campaigns/advertisers/{campaignAdvertiserId}/ladder
     */
    getCampaignLadder: (
      campaignAdvertiserId: string,
      query?: {
        /** 分页参数 */
        nextToken?: string;
        /**
         * 分页参数
         * @format int32
         * @default 100
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<CampaignLadderResponse, any>({
        path: `/v1/campaigns/advertisers/${campaignAdvertiserId}/ladder`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 获取我的邀请列表
     *
     * @tags Campaign
     * @name GetCampaignInvites
     * @summary 获取邀请列表
     * @request GET:/v1/campaigns/advertisers/{campaignAdvertiserId}/invites
     */
    getCampaignInvites: (
      campaignAdvertiserId: string,
      query?: {
        /** 分页参数 */
        nextToken?: string;
        /**
         * 分页参数(最大 100)
         * @format int32
         * @default 10
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<CampaignInvitesResponse, any>({
        path: `/v1/campaigns/advertisers/${campaignAdvertiserId}/invites`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 查询我邀请用户在各档位的聚合统计
     *
     * @tags Campaign
     * @name GetCampaignInviteTierStats
     * @summary 获取邀请档位聚合统计
     * @request GET:/v1/campaigns/advertisers/{campaignAdvertiserId}/invites/tier-stats
     */
    getCampaignInviteTierStats: (
      campaignAdvertiserId: string,
      params: RequestParams = {},
    ) =>
      this.request<CampaignInviteTierStatsResponse, any>({
        path: `/v1/campaigns/advertisers/${campaignAdvertiserId}/invites/tier-stats`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description 返回当前唯一 active 活动的详情（与 `GET /campaigns/advertisers/{campaignAdvertiserId}` 的响应结构一致：`obj` 为单条 `AdvertiserDetail`，不包含 `campaigns` 列表）。
     *
     * @tags Campaign
     * @name GetActiveCampaigns
     * @summary 获取当前生效活动详情
     * @request GET:/v1/campaigns/active
     */
    getActiveCampaigns: (params: RequestParams = {}) =>
      this.request<AdvertiserDetailResponse, any>({
        path: `/v1/campaigns/active`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description 获取签名
     *
     * @tags Auth
     * @name Sign
     * @summary 获取签名
     * @request GET:/v1/auth/{type}/sign
     */
    sign: (type: string, params: RequestParams = {}) =>
      this.request<SignResponse, any>({
        path: `/v1/auth/${type}/sign`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description third platform bind lists
     *
     * @tags Auth
     * @name ThirdBindings
     * @summary /customer/auth/third/bindings
     * @request GET:/v1/auth/third/bindings
     * @secure
     */
    thirdBindings: (params: RequestParams = {}) =>
      this.request<ThirdBindingsResponse, any>({
        path: `/v1/auth/third/bindings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 获取一个密钥
     *
     * @tags Auth
     * @name Challenge
     * @summary 获取一个密钥
     * @request GET:/v1/auth/challenge
     * @secure
     */
    challenge: (
      query: {
        /** 地址 */
        address: string;
        /**
         * 登录送wallet or social，绑定钱包送bind_wallet
         * @default "social"
         */
        type?: string;
        /** 钱包类型, 默认送EVM */
        walletType?: "EVM" | "SOLANA";
      },
      params: RequestParams = {},
    ) =>
      this.request<ChallengeResponse, any>({
        path: `/v1/auth/challenge`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 队长移除团队成员
     *
     * @tags Team
     * @name RemoveTeamMember
     * @summary Remove member by captain
     * @request DELETE:/v1/teams/remove/{userId}
     */
    removeTeamMember: (userId: string[], params: RequestParams = {}) =>
      this.request<WebResultRemoveMemberResponse, any>({
        path: `/v1/teams/remove/${userId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * @description 退出当前团队
     *
     * @tags Team
     * @name LeaveTeam
     * @summary Leave team (self)
     * @request DELETE:/v1/teams/leave
     */
    leaveTeam: (params: RequestParams = {}) =>
      this.request<WebResultLeaveTeamResponse, any>({
        path: `/v1/teams/leave`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * @description 分页列出当前 passport 关联项目方下的 Campaign / 申请单；支持按状态过滤。
     *
     * @tags CampaignDashboard
     * @name ListMyCampaigns
     * @summary 列出当前项目方旗下 Campaign（合并 application + 已审批 Campaign）
     * @request GET:/v1/growth/dashboard/campaigns
     * @secure
     */
    listMyCampaigns: (
      query?: {
        /** 状态过滤；多值可重复传参。取值 ∈ {DRAFT, PENDING, APPROVED, LIVE, SETTLING, COMPLETED}。REJECTED 默认不返回。空表示返回全部（除 REJECTED）。 */
        statusFilter?: string[];
        /**
         * @format int32
         * @default 1
         */
        page?: number;
        /**
         * @format int32
         * @default 20
         */
        size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<MyCampaignPageResponse, any>({
        path: `/v1/growth/dashboard/campaigns`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description 返回 metadata + 统计卡 + actionsTrend（Total / By Quest）+ questPerformance + 退款信息。404 表示不存在或无权访问。
     *
     * @tags CampaignDashboard
     * @name GetCampaignDashboard
     * @summary Campaign Dashboard 聚合详情视图
     * @request GET:/v1/growth/dashboard/campaigns/{campaignId}
     * @secure
     */
    getCampaignDashboard: (
      campaignId: string,
      query?: {
        /**
         * 时间窗口，与 Dashboard 时间筛选一致；默认 LAST_24H。
         * @default "LAST_24H"
         */
        timeWindow?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<CampaignDashboardViewResponse, any>({
        path: `/v1/growth/dashboard/campaigns/${campaignId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
